'use strict';


    const GOOGLE_MAPS_API_KEY = ''; // Optional: add your Google Maps API key to enable address autocomplete.

    function loadGooglePlacesAutocomplete() {
      if (!GOOGLE_MAPS_API_KEY) return;

      const existingScript = document.getElementById('googleMapsPlacesScript');
      if (existingScript) return;

      window.initProjectAddressAutocomplete = function() {
        const input = document.getElementById('projectAddress');
        if (!input || !window.google || !google.maps || !google.maps.places) return;

        const autocomplete = new google.maps.places.Autocomplete(input, {
          fields: ['formatted_address', 'address_components', 'geometry'],
          componentRestrictions: { country: ['ca', 'us'] }
        });

        autocomplete.addListener('place_changed', function() {
          const place = autocomplete.getPlace();
          if (place && place.formatted_address) {
            input.value = place.formatted_address;
          }
        });
      };

      const script = document.createElement('script');
      script.id = 'googleMapsPlacesScript';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(GOOGLE_MAPS_API_KEY) + '&libraries=places&callback=initProjectAddressAutocomplete';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

let currentMaterials = [];
    let recommendedMaterialsSnapshot = [];
    let materialsManuallyEdited = false;
    let removedMaterialsHistory = [];
    let changedMaterialKeys = new Set();
    const quoteId = 'Q-' + new Date().toISOString().slice(0,10).replace(/-/g, '') + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();

    const MEASUREMENT_INPUTS = {
      TOTAL_PITCH_AREA: 'area', TOTAL_FLAT_AREA: 'flatArea', EAVES_LENGTH: 'eaves', RAKES_LENGTH: 'rakes', RIDGES_LENGTH: 'ridges', HIPS_LENGTH: 'hips', VALLEYS_LENGTH: 'valleys', WALL_FLASHING_LENGTH: 'walls', STEP_FLASHING_LENGTH: 'steps', PARAPET_LENGTH: 'parapet'
    };

    function getInputNumber(id) { const el = document.getElementById(id); return el ? parseFloat(el.value) || 0 : 0; }
    function getInputText(id) { const el = document.getElementById(id); return el ? String(el.value || '') : ''; }
    function getFlatRoofSlopeNumber() { return parseFloat(getInputText('flatRoofSlope').replace('%', '')) || 0; }
    function roundUp(value) { return Math.ceil(Math.max(Number(value) || 0, 0)); }

    function roundUpToIncrement(value, increment) {
      const safeIncrement = Math.max(Number(increment) || 1, 1);
      return Math.ceil(Math.max(Number(value) || 0, 0) / safeIncrement) * safeIncrement;
    }

    function proPitchConfig(type) {
      const configs = {
        eaves: { label: 'Eaves', inputId: 'eaves', enabledId: 'eavesProEnabled', panelId: 'eavesProPanel', rowsId: 'eavesProRows', summaryId: 'eavesProSummary' },
        ridges: { label: 'Ridges', inputId: 'ridges', enabledId: 'ridgesProEnabled', panelId: 'ridgesProPanel', rowsId: 'ridgesProRows', summaryId: 'ridgesProSummary' }
      };
      return configs[type] || null;
    }

    function pitchOptionsHtml(selectedPitch) {
      const selected = selectedPitch || getInputText('pitch') || '6/12';
      const options = [];
      for (let i = 1; i <= 24; i += 1) {
        const value = i + '/12';
        options.push('<option value="' + value + '"' + (value === selected ? ' selected' : '') + '>' + value + '</option>');
      }
      return options.join('');
    }

    function getProPitchRows(type) {
      const config = proPitchConfig(type);
      const container = config ? document.getElementById(config.rowsId) : null;
      if (!container) return [];

      return Array.from(container.querySelectorAll('.pro-pitch-row')).map(function(row) {
        const lengthInput = row.querySelector('.pro-pitch-length');
        const pitchSelect = row.querySelector('.pro-pitch-select');
        const length = parseFloat(lengthInput ? lengthInput.value : '') || 0;
        return {
          length: length,
          pitch: pitchSelect ? pitchSelect.value : getInputText('pitch'),
          adjustedLength: length > 0 ? roundUpToIncrement(length, 10) : 0
        };
      }).filter(function(item) { return item.length > 0; });
    }

    function isProPitchEnabled(type) {
      const config = proPitchConfig(type);
      const checkbox = config ? document.getElementById(config.enabledId) : null;
      return !!(checkbox && checkbox.checked);
    }

    function effectiveMeasuredLength(type) {
      if (!isProPitchEnabled(type) || isMetalTilesSelected()) return getInputNumber(type);
      const rows = getProPitchRows(type);
      if (!rows.length) return roundUpToIncrement(getInputNumber(type), 10);
      return rows.reduce(function(sum, row) { return sum + row.adjustedLength; }, 0);
    }

    function proPitchBreakdown(type, coverage) {
      if (!isProPitchEnabled(type) || isMetalTilesSelected()) return [];
      const rows = getProPitchRows(type);
      if (!rows.length) return [];
      const safeCoverage = Math.max(Number(coverage) || 10, 1);
      return rows.map(function(row, index) {
        return {
          label: (proPitchConfig(type).label || type) + ' slope #' + (index + 1),
          originalLength: row.length,
          adjustedLength: row.adjustedLength,
          pitch: row.pitch,
          qty: roundUp(row.adjustedLength / safeCoverage)
        };
      });
    }

    function formatFlashingBreakdownLines(item) {
      const lines = [];
      (item.flashingBreakdown || []).forEach(function(part) {
        lines.push(part.label + ': ' + part.originalLength.toFixed(2) + ' ft entered -> ' + part.adjustedLength.toFixed(0) + ' ln.ft. / ' + part.qty + ' pcs / pitch ' + part.pitch);
      });
      if (item.extraBreakdownNote) lines.push(item.extraBreakdownNote);
      return lines;
    }

    function updateProModeAvailability() {
      const enabled = !isMetalTilesSelected();
      ['eaves', 'ridges'].forEach(function(type) {
        const config = proPitchConfig(type);
        if (!config) return;
        const card = document.getElementById(type + 'ProCard');
        const checkbox = document.getElementById(config.enabledId);
        const panel = document.getElementById(config.panelId);
        if (card) card.classList.toggle('is-hidden', !enabled);
        if (!enabled && checkbox) checkbox.checked = false;
        if (!enabled && panel) panel.hidden = true;
      });
    }

    function updateProPitchSummary(type) {
      const config = proPitchConfig(type);
      const summary = config ? document.getElementById(config.summaryId) : null;
      if (!summary) return;

      const rows = getProPitchRows(type);
      const enteredTotal = rows.length ? rows.reduce(function(sum, row) { return sum + row.length; }, 0) : getInputNumber(type);
      const adjustedTotal = effectiveMeasuredLength(type);
      const difference = Math.max(adjustedTotal - enteredTotal, 0);
      summary.classList.toggle('warning-summary', rows.length === 0);
      summary.textContent = rows.length
        ? config.label + ' entered: ' + enteredTotal.toFixed(2) + ' ft. Adjusted for 10 ft flashings: ' + adjustedTotal.toFixed(0) + ' ln.ft. Added by rounding: ' + difference.toFixed(2) + ' ft.'
        : 'Add at least one ' + config.label.toLowerCase() + ' slope. Until then, the total field is rounded up to the next 10 ft.';
    }

    function syncProPitch(type, recalculate) {
      const config = proPitchConfig(type);
      if (!config) return;
      const checkbox = document.getElementById(config.enabledId);
      const panel = document.getElementById(config.panelId);
      const container = document.getElementById(config.rowsId);
      if (!checkbox || !panel || !container) return;

      updateProModeAvailability();
      if (isMetalTilesSelected()) {
        updateProPitchSummary(type);
        if (recalculate) calculateMaterials();
        return;
      }

      panel.hidden = !checkbox.checked;
      if (checkbox.checked && !container.children.length) {
        addProPitchRow(type, getInputNumber(config.inputId), getInputText('pitch') || '6/12', false);
      }
      updateProPitchSummary(type);
      if (recalculate) calculateMaterials();
    }

    function addProPitchRow(type, lengthValue, pitchValue, recalculate) {
      const config = proPitchConfig(type);
      const container = config ? document.getElementById(config.rowsId) : null;
      if (!container) return;
      const rowNumber = container.children.length + 1;
      const row = document.createElement('div');
      row.className = 'pro-pitch-row';
      row.dataset.type = type;
      row.innerHTML = '<div class="field"><label>' + config.label + ' slope #' + rowNumber + ', ln. ft.</label><input class="pro-pitch-length" type="number" min="0" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" value="' + (lengthValue !== undefined ? String(lengthValue) : '') + '" /></div>' +
        '<div class="field"><label>Pitch</label><select class="pro-pitch-select">' + pitchOptionsHtml(pitchValue) + '</select></div>' +
        '<button class="pro-remove-row-btn" type="button" onclick="removeProPitchRow(this)">Remove</button>';
      container.appendChild(row);
      updateProPitchSummary(type);
      if (recalculate !== false) calculateMaterials();
    }

    function removeProPitchRow(button) {
      const row = button ? button.closest('.pro-pitch-row') : null;
      const type = row ? row.dataset.type : '';
      if (row) row.remove();
      updateProPitchSummary(type);
      calculateMaterials();
    }

    function setupProPitchControls() {
      ['eaves', 'ridges'].forEach(function(type) {
        const config = proPitchConfig(type);
        const checkbox = config ? document.getElementById(config.enabledId) : null;
        if (checkbox && !checkbox.dataset.bound) {
          checkbox.dataset.bound = 'true';
          checkbox.addEventListener('change', function() { syncProPitch(type, true); });
        }
        syncProPitch(type, false);
      });
    }

    function setSelectOptions(selectId, options, preferredValue) {
      const select = document.getElementById(selectId);
      if (!select) return;
      select.textContent = '';
      options.forEach(function(optionValue) {
        const option = document.createElement('option');
        option.value = optionValue;
        option.textContent = optionValue;
        select.appendChild(option);
      });
      select.value = options.includes(preferredValue) ? preferredValue : options[0];
    }

    function isCascadiaColorCatalogSelected() {
      return !isMetalTilesSelected() &&
        getInputText('manufacturer') === 'Cascadia Metals LTD' &&
        typeof CASCADIA_COLOR_CATALOG !== 'undefined' &&
        CASCADIA_COLOR_CATALOG;
    }

    function selectedBaseCoating() {
      const coating = getInputText('coating');
      if (coating === 'SMP Textured') return 'SMP';
      if (coating === 'Printed SMP') return 'SMP';
      if (coating === 'Printed PVDF') return 'PVDF';
      return coating;
    }

    function selectedEffectiveFinish() {
      const coating = getInputText('coating');
      if (coating === 'SMP Textured') return 'Textured';
      if (coating === 'Printed SMP') return 'Printed';
      if (coating === 'Printed PVDF') return 'Printed';
      return getInputText('finish');
    }

    function cascadiaCoatingOptions() {
      if (!isCascadiaColorCatalogSelected()) return [];
      return Object.keys(CASCADIA_COLOR_CATALOG);
    }

    function currentCascadiaCoatingRecord() {
      if (!isCascadiaColorCatalogSelected()) return null;
      return CASCADIA_COLOR_CATALOG[getInputText('coating')] || null;
    }

    function currentCascadiaColorRecord() {
      const record = currentCascadiaCoatingRecord();
      if (!record || !Array.isArray(record.colors)) return null;
      const selectedColor = getInputText('color');
      return record.colors.find(function(item) {
        return item.name === selectedColor;
      }) || record.colors[0] || null;
    }

    function ensureCascadiaColorPreview() {
      const field = document.getElementById('colorField');
      const select = document.getElementById('color');
      if (!field || !select) return null;

      let picker = document.getElementById('cascadiaColorPicker');
      if (!picker) {
        picker = document.createElement('div');
        picker.id = 'cascadiaColorPicker';
        picker.className = 'cascadia-color-picker';
        field.appendChild(picker);
      }

      if (select.parentNode !== picker) {
        picker.insertBefore(select, picker.firstChild);
      }
      select.classList.add('cascadia-native-color-select');
      select.setAttribute('tabindex', '-1');
      select.setAttribute('aria-hidden', 'true');

      let button = picker.querySelector('.cascadia-color-button');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'cascadia-color-button';
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        picker.appendChild(button);

        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!isCascadiaColorCatalogSelected()) return;
          const isOpen = picker.classList.toggle('is-open');
          button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          renderCascadiaColorPreview();
        });
      }

      let menu = picker.querySelector('.cascadia-color-menu');
      if (!menu) {
        menu = document.createElement('div');
        menu.className = 'cascadia-color-menu';
        menu.setAttribute('role', 'listbox');
        picker.appendChild(menu);
      }

      let card = document.getElementById('cascadiaColorPreview');
      if (!card) {
        card = document.createElement('div');
        card.id = 'cascadiaColorPreview';
        card.className = 'cascadia-color-preview-card';
        picker.appendChild(card);
      } else if (card.parentNode !== picker) {
        picker.appendChild(card);
      }

      if (!picker.dataset.outsideBound) {
        picker.dataset.outsideBound = 'true';
        document.addEventListener('click', function(event) {
          if (!picker.contains(event.target)) {
            picker.classList.remove('is-open');
            const btn = picker.querySelector('.cascadia-color-button');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            hideCascadiaColorPreview();
          }
        });
      }

      return picker;
    }

    function hideCascadiaColorPreview() {
      const card = document.getElementById('cascadiaColorPreview');
      if (!card) return;
      card.hidden = true;
      card.textContent = '';
    }

    function renderCascadiaColorPreview(colorRecord) {
      const picker = ensureCascadiaColorPreview();
      if (!picker) return;

      const button = picker.querySelector('.cascadia-color-button');
      const menu = picker.querySelector('.cascadia-color-menu');
      const card = document.getElementById('cascadiaColorPreview');
      const select = document.getElementById('color');

      if (!isCascadiaColorCatalogSelected()) {
        picker.hidden = true;
        if (select) {
          select.classList.remove('cascadia-native-color-select');
          select.removeAttribute('aria-hidden');
          select.removeAttribute('tabindex');
          if (fieldVisibleSelectParent(select, picker)) {
            const field = document.getElementById('colorField');
            if (field) field.appendChild(select);
          }
        }
        hideCascadiaColorPreview();
        return;
      }

      picker.hidden = false;
      const record = currentCascadiaCoatingRecord();
      const colors = record && Array.isArray(record.colors) ? record.colors : [];
      const selectedColor = currentCascadiaColorRecord();
      const activeColor = colorRecord || selectedColor;
      const coating = getInputText('coating');
      const finish = getInputText('finish');

      if (button) {
        button.innerHTML = '<span class="cascadia-color-button-text">' + (selectedColor ? selectedColor.name : 'Select color') + '</span><span class="cascadia-color-button-arrow">▾</span>';
      }

      if (menu) {
        menu.textContent = '';
        colors.forEach(function(color) {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'cascadia-color-option';
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', selectedColor && selectedColor.name === color.name ? 'true' : 'false');
          item.textContent = color.name;

          item.addEventListener('mouseenter', function() {
            showCascadiaColorPreview(color);
          });
          item.addEventListener('focus', function() {
            showCascadiaColorPreview(color);
          });
          item.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            const colorSelect = document.getElementById('color');
            if (colorSelect) {
              colorSelect.value = color.name;
              colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
            picker.classList.remove('is-open');
            if (button) button.setAttribute('aria-expanded', 'false');
            hideCascadiaColorPreview();
          });
          menu.appendChild(item);
        });

        menu.addEventListener('mouseleave', hideCascadiaColorPreview);
      }

      if (activeColor && picker.classList.contains('is-open')) {
        showCascadiaColorPreview(activeColor, coating, finish);
      } else if (card) {
        card.hidden = true;
      }
    }

    function fieldVisibleSelectParent(select, picker) {
      return !!(select && picker && select.parentNode === picker);
    }

    function showCascadiaColorPreview(color, coatingOverride, finishOverride) {
      const picker = ensureCascadiaColorPreview();
      const card = document.getElementById('cascadiaColorPreview');
      if (!picker || !card || !color) return;

      const coating = coatingOverride || getInputText('coating');
      const finish = finishOverride || getInputText('finish');

      card.hidden = false;
      card.textContent = '';

      const imageWrap = document.createElement('div');
      imageWrap.className = 'cascadia-color-preview-image-wrap';

      if (color.image) {
        const img = document.createElement('img');
        img.className = 'cascadia-color-preview-image';
        img.loading = 'lazy';
        img.alt = color.name;
        img.src = color.image;
        imageWrap.appendChild(img);
      } else {
        imageWrap.textContent = 'No image';
      }

      const body = document.createElement('div');
      body.className = 'cascadia-color-preview-body';

      const title = document.createElement('strong');
      title.textContent = color.name;

      const meta = document.createElement('span');
      meta.textContent = coating + ' | ' + finish;

      body.appendChild(title);
      body.appendChild(meta);
      card.appendChild(imageWrap);
      card.appendChild(body);
    }

    function applyCascadiaMaterialOptions(preferredCoating, preferredColor) {
      if (!isCascadiaColorCatalogSelected()) {
        const finish = document.getElementById('finish');
        const picker = document.getElementById('cascadiaColorPicker');
        const select = document.getElementById('color');
        if (finish) finish.disabled = false;
        if (picker) picker.hidden = true;
        if (select) {
          select.classList.remove('cascadia-native-color-select');
          select.removeAttribute('aria-hidden');
          select.removeAttribute('tabindex');
          const field = document.getElementById('colorField');
          if (field && select.parentNode !== field) field.appendChild(select);
        }
        hideCascadiaColorPreview();
        return false;
      }

      const coatings = cascadiaCoatingOptions();
      const coatingValue = coatings.includes(preferredCoating || getInputText('coating'))
        ? (preferredCoating || getInputText('coating'))
        : coatings[0];

      setSelectOptions('coating', coatings, coatingValue);

      const record = currentCascadiaCoatingRecord();
      const finishValue = record ? record.finish : 'Glossy';
      setSelectOptions('finish', [finishValue], finishValue);

      const finish = document.getElementById('finish');
      if (finish) finish.disabled = true;

      const colors = record && Array.isArray(record.colors)
        ? record.colors.map(function(item) { return item.name; })
        : [];

      setSelectOptions('color', colors, colors.includes(preferredColor || getInputText('color')) ? (preferredColor || getInputText('color')) : colors[0]);

      ensureCascadiaColorPreview();
      renderCascadiaColorPreview();
      return true;
    }

    function isMetalTilesSelected() {
      return getInputText('system') === 'metal_tiles';
    }

    function getSteelOptions() {
      const manufacturer = getInputText('manufacturer');
      if (isMetalTilesSelected()) {
        return METAL_TILE_OPTIONS[manufacturer] || METAL_TILE_OPTIONS['Vietnam - budget friendly option'];
      }
      return STEEL_OPTIONS[manufacturer] || STEEL_OPTIONS['Cascadia Metals LTD'];
    }

    function populateManufacturerOptions() {
      const manufacturer = document.getElementById('manufacturer');
      if (!manufacturer) return;
      const current = manufacturer.value;
      const options = isMetalTilesSelected() ? Object.keys(METAL_TILE_OPTIONS) : Object.keys(STEEL_OPTIONS);
      manufacturer.textContent = '';
      options.forEach(function(optionValue) {
        const option = document.createElement('option');
        option.value = optionValue;
        option.textContent = optionValue;
        manufacturer.appendChild(option);
      });
      manufacturer.value = options.includes(current) ? current : options[0];
    }

    function populateMetalTileStyleOptions() {
      const lockType = document.getElementById('lockType');
      if (!lockType) return;

      if (!isMetalTilesSelected()) {
        lockType.textContent = '';
        [{ value: 'mechanical', label: "Mechanical lock 1-1/2''" }, { value: 'snap', label: "Snap lock 1-1/2''" }].forEach(function(item) {
          const option = document.createElement('option');
          option.value = item.value;
          option.textContent = item.label;
          lockType.appendChild(option);
        });
        lockType.value = 'mechanical';
        return;
      }

      const options = getSteelOptions().styles || ['Monterrey (28 sq.ft. - 6 modules)'];
      lockType.textContent = '';
      options.forEach(function(optionValue) {
        const option = document.createElement('option');
        option.value = optionValue;
        option.textContent = optionValue;
        lockType.appendChild(option);
      });
      lockType.value = options[0];
    }

    function moveField(fieldId, targetId) {
      const field = document.getElementById(fieldId);
      const target = document.getElementById(targetId);
      if (field && target && field.parentNode !== target) target.appendChild(field);
    }

    function restoreField(fieldId, fallbackId) {
      const field = document.getElementById(fieldId);
      const fallback = document.getElementById(fallbackId);
      if (field && fallback && field.parentNode !== fallback) fallback.appendChild(field);
    }

    function insertFieldBefore(fieldId, beforeFieldId) {
      const field = document.getElementById(fieldId);
      const beforeField = document.getElementById(beforeFieldId);
      if (field && beforeField && beforeField.parentNode) beforeField.parentNode.insertBefore(field, beforeField);
    }

    function updateSystemSpecificUI() {
      const isMetal = isMetalTilesSelected();
      const lockTypeLabelEl = document.getElementById('lockTypeLabel');
      const panelsFeatureField = document.getElementById('panelsFeatureField');
      const flashingGaugeField = document.getElementById('flashingGaugeField');
      const panelGaugeField = document.getElementById('panelGaugeField');
      const thicknessSection = document.getElementById('thicknessSection');
      const snowRetentionField = document.getElementById('snowRetentionField');
      const membraneField = document.getElementById('membraneField');
      const closureField = document.getElementById('closureField');
      const vmaxTowerVentField = document.getElementById('vmaxTowerVentField');
      const metalManufacturerSlot = document.getElementById('metalManufacturerSlot');
      const metalGaugeSlot = document.getElementById('metalGaugeSlot');

      if (isMetal) {
        moveField('manufacturerField', 'metalManufacturerSlot');
        moveField('panelGaugeField', 'metalGaugeSlot');
      } else {
        restoreField('manufacturerField', 'materialSelectionSection');
        restoreField('panelGaugeField', 'thicknessSection');
        insertFieldBefore('manufacturerField', 'coatingField');
        insertFieldBefore('finishField', 'colorField');
        ensureCascadiaColorPreview();
      }

      if (lockTypeLabelEl) lockTypeLabelEl.textContent = isMetal ? 'Metal Tiles Style' : 'Standing Seam Lock Type';
      if (panelsFeatureField) panelsFeatureField.classList.toggle('is-hidden', isMetal);
      if (flashingGaugeField) flashingGaugeField.classList.toggle('is-hidden', isMetal);
      if (thicknessSection) thicknessSection.classList.toggle('is-hidden', isMetal);
      if (snowRetentionField) snowRetentionField.classList.toggle('is-hidden', isMetal);
      if (membraneField) membraneField.classList.toggle('is-hidden', !isMetal);
      if (closureField) closureField.classList.toggle('is-hidden', !isMetal);
      if (vmaxTowerVentField) vmaxTowerVentField.classList.toggle('is-hidden', !isMetal);
      if (metalManufacturerSlot) metalManufacturerSlot.classList.toggle('is-hidden', !isMetal);
      if (metalGaugeSlot) metalGaugeSlot.classList.toggle('is-hidden', !isMetal);
      updateProModeAvailability();
    }


    function applyMaterialAvailabilityRules() {
      const manufacturer = getInputText('manufacturer');
      const coating = selectedBaseCoating();
      const isSsab = manufacturer === 'SSAB';
      const isPvdf = coating === 'PVDF' && !isSsab;
      const isCascadiaManaged = isCascadiaColorCatalogSelected();

      const finish = document.getElementById('finish');
      if (finish && !isCascadiaManaged) {
        const texturedOption = Array.from(finish.options).find(function(option) { return option.value === 'Textured'; });
        if (texturedOption) {
          texturedOption.disabled = isPvdf;
          texturedOption.textContent = isPvdf ? 'Textured - unavailable for PVDF' : 'Textured';
        }
        finish.disabled = false;
        finish.classList.toggle('has-disabled-options', isPvdf);
        if (isPvdf && finish.value === 'Textured') finish.value = 'Glossy';
      } else if (finish && isCascadiaManaged) {
        finish.classList.remove('has-disabled-options');
      }

      ['gauge', 'flashingGauge'].forEach(function(selectId) {
        const select = document.getElementById(selectId);
        if (!select) return;

        Array.from(select.options).forEach(function(option) {
          if (option.value === '26GA') {
            option.disabled = isPvdf;
            option.textContent = isPvdf ? '26GA - unavailable for PVDF' : '26GA';
          }
          if (option.value === '24GA') {
            option.disabled = false;
            option.textContent = '24GA';
          }
        });

        select.classList.toggle('has-unavailable-gauge', isPvdf);

        if (isPvdf) select.value = '24GA';
        if (isSsab) select.value = getInputText('gauge');
      });

      if (isPvdf && finish && !isCascadiaManaged) finish.value = 'Glossy';
      renderCascadiaColorPreview();
    }


    function updateSteelOptions(recalculate) {
      populateManufacturerOptions();
      const options = getSteelOptions();
      const preferredCoating = getInputText('coating');
      const preferredColor = getInputText('color');
      setSelectOptions('gauge', options.gauges, getInputText('gauge'));
      setSelectOptions('coating', options.coatings, preferredCoating);
      setSelectOptions('finish', options.finishes, getInputText('finish'));
      setSelectOptions('color', options.colors, preferredColor);
      syncFlashingGaugeOptions(false);
      populateMetalTileStyleOptions();
      updateSystemSpecificUI();
      applyCascadiaMaterialOptions(preferredCoating, preferredColor);
      applyMaterialAvailabilityRules();
      if (recalculate) calculateMaterials();
    }

    function syncFlashingGaugeOptions(keepCurrent) {
      const options = getSteelOptions();
      const manufacturer = getInputText('manufacturer');
      const preferred = keepCurrent ? getInputText('flashingGauge') : getInputText('gauge');
      setSelectOptions('flashingGauge', options.gauges, preferred);
      const flashingGauge = document.getElementById('flashingGauge');
      if (flashingGauge) {
        flashingGauge.disabled = manufacturer === 'SSAB';
        if (manufacturer === 'SSAB') flashingGauge.value = getInputText('gauge');
      }
    }



    function populateFlatRoofSlopeOptions(preferredValue) {
      const values = ['1%', '1.5%', '2%', '2.5%', '3%', '3.5%', '4%', '4.5%', '4.76%'];
      setSelectOptions('flatRoofSlope', values, preferredValue || '1%');
    }

    function populateWasteFactorOptions(preferredValue) {
      const values = [];
      for (let i = 0; i <= 25; i += 1) {
        values.push(String(i));
      }
      setSelectOptions('wasteFactor', values, preferredValue || '0');
    }

    function populatePitchOptions(preferredValue) {
      const pitches = [];
      for (let i = 1; i <= 24; i += 1) {
        pitches.push(i + '/12');
      }
      setSelectOptions('pitch', pitches, preferredValue || '6/12');
    }



    function updateDeliveryNotice() {
      const notice = document.getElementById('deliveryResponsibilityNotice');
      if (!notice) return;
      notice.style.display = getInputText('needDelivery') === 'no' ? 'none' : 'block';
    }

    function sanitizeNumberInput(input) {
      if (!input || input.type !== 'number') return;
      const cleaned = String(input.value || '')
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*)\./g, '$1');
      input.value = cleaned;
      input.classList.toggle('invalid-number', cleaned === '' && input.required);
    }

    function setupNumericInputs() {
      document.querySelectorAll('input[type="number"]').forEach(function(input) {
        input.setAttribute('inputmode', 'decimal');
        input.setAttribute('pattern', '[0-9]*[.]?[0-9]*');
        input.addEventListener('keydown', function(event) {
          if (['e', 'E', '+', '-'].includes(event.key)) event.preventDefault();
        });
        input.addEventListener('paste', function(event) {
          event.preventDefault();
          const text = (event.clipboardData || window.clipboardData).getData('text');
          input.value = String(text || '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    }

    function getFormSections() {
      return Array.from(document.querySelectorAll('.form-grid > .form-section'));
    }

    function getSectionControls(section) {
      return Array.from(section.querySelectorAll('input, select')).filter(function(control) {
        return control.offsetParent !== null;
      });
    }

    function isControlFilled(control) {
      if (control.type === 'number') return String(control.value || '').trim() !== '' && Number(control.value) >= 0;
      return String(control.value || '').trim() !== '';
    }

    function isSectionComplete(section) {
      const controls = getSectionControls(section);
      return controls.length ? controls.every(isControlFilled) : true;
    }

    function expandFormSection(section) {
      getFormSections().forEach(function(item) {
        item.classList.toggle('is-active', item === section);
        item.classList.toggle('is-collapsed', item !== section && item.dataset.completed === 'true');
      });
    }

    function updateCollapsibleSections(changedControl) {
      const sections = getFormSections();
      if (!sections.length) return;

      sections.forEach(function(section) {
        section.dataset.completed = isSectionComplete(section) ? 'true' : 'false';
      });

      const activeSection = document.querySelector('.form-section.is-active') || sections[0];
      const changedSection = changedControl ? changedControl.closest('.form-section') : null;

      if (changedSection && changedSection === activeSection && isSectionComplete(changedSection)) {
        const nextSection = sections.slice(sections.indexOf(changedSection) + 1).find(function(section) {
          return section.dataset.completed !== 'true';
        });
        if (nextSection) {
          expandFormSection(nextSection);
          return;
        }
      }

      sections.forEach(function(section) {
        if (section !== activeSection && section.dataset.completed === 'true') {
          section.classList.add('is-collapsed');
        }
      });
    }

    function setupCollapsibleSections() {
      const sections = getFormSections();
      sections.forEach(function(section, index) {
        const editButton = section.querySelector('.section-edit-btn');
        if (editButton && !editButton.dataset.bound) {
          editButton.dataset.bound = 'true';
          editButton.addEventListener('click', function() {
            expandFormSection(section);
          });
        }
        section.classList.toggle('is-active', index === 0);
        section.classList.remove('is-collapsed');
      });
      updateCollapsibleSections();
    }

    function setupAutoCalculate() {
      const calculator = document.querySelector('.roof-calculator');
      if (!calculator) return;

      setupNumericInputs();

      calculator.addEventListener('input', function(event) {
        if (event.target && event.target.matches('input')) {
          sanitizeNumberInput(event.target);
          if (event.target.classList.contains('pro-pitch-length')) {
            const row = event.target.closest('.pro-pitch-row');
            if (row) updateProPitchSummary(row.dataset.type);
          }
          if (event.target.id === 'eaves') updateProPitchSummary('eaves');
          if (event.target.id === 'ridges') updateProPitchSummary('ridges');
          calculateMaterials();
          updateCollapsibleSections(event.target);
        }
      });

      calculator.addEventListener('change', function(event) {
        if (!event.target) return;
        if (event.target.classList.contains('pro-pitch-select')) {
          const row = event.target.closest('.pro-pitch-row');
          if (row) updateProPitchSummary(row.dataset.type);
          calculateMaterials();
          updateCollapsibleSections(event.target);
          return;
        }
        if (!event.target.matches('select')) return;
        if (event.target.id === 'system') {
          materialsManuallyEdited = false;
          removedMaterialsHistory = [];
          updateSteelOptions(false);
        } else if (event.target.id === 'manufacturer') {
          updateSteelOptions(false);
        } else if (event.target.id === 'coating') {
          applyCascadiaMaterialOptions(getInputText('coating'), '');
        } else if (event.target.id === 'color') {
          renderCascadiaColorPreview();
        }
        if (event.target.id === 'coating' || event.target.id === 'gauge' || event.target.id === 'flashingGauge' || event.target.id === 'finish') {
          applyMaterialAvailabilityRules();
        }
        if (event.target.id === 'needDelivery') {
          updateDeliveryNotice();
        }
        calculateMaterials();
        updateCollapsibleSections(event.target);
      });
    }
    function money(value) { return '$' + (Number(value) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

    function formatDateTime(value) {
      return value.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    function formatDateOnly(value) {
      return value.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      });
    }

    function isStandingSeamPanel(product) {
      const name = String(product.name || '').toLowerCase();
      return product.system === 'standing_seam' && product.measurement === 'TOTAL_PITCH_AREA' && (name.includes('standing seam metal roof') || name.includes('greencoat pural'));
    }

    function isMetalTilePanel(product) {
      return product.uuid === '56-metal-tiles';
    }

    function metalTileStyleLabel() {
      return getInputText('lockType') || 'Monterrey (28 sq.ft. - 6 modules)';
    }

    function getMetalTilePricing() {
      return METAL_TILE_PRICING[getInputText('manufacturer')] || METAL_TILE_PRICING['Vietnam - budget friendly option'];
    }


    const SHOPIFY_VARIANT_CACHE_BY_SKU = {};
    const SHOPIFY_PRODUCT_CACHE_BY_HANDLE = {};
    let shopifyCatalogLoadStarted = false;
    let shopifyCatalogLoaded = false;

    function cleanSkuPart(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function selectedColorCode() {
      const color = getInputText('color');
      const rr = String(color || '').toUpperCase().match(/RR[0-9A-Z]+/);
      if (rr) return rr[0];
      const colorMap = {
        'BLACK': 'BL',
        'CHARCOAL': 'CH',
        'DARK BROWN': 'DA',
        'WHITE': 'WH',
        'CUSTOM': 'CU'
      };
      return colorMap[String(color || '').toUpperCase()] || cleanSkuPart(color).slice(0, 2);
    }

    function selectedGaugeCode(gaugeValue) {
      const gauge = String(gaugeValue || getInputText('flashingGauge') || getInputText('gauge') || '').toUpperCase();
      if (gauge.includes('25GA') || gauge.includes('0.5MM')) return '25GA';
      if (gauge.includes('24GA')) return '24GA';
      if (gauge.includes('26GA')) return '26GA';
      if (gauge.includes('28GA')) return '28GA';
      return cleanSkuPart(gauge);
    }

    function selectedFinishCode() {
      const finish = selectedEffectiveFinish();
      if (String(finish).toLowerCase().includes('textured')) return 'TX';
      if (String(finish).toLowerCase().includes('standard')) return 'ST';
      return 'GL';
    }

    function selectedMaterialSkuSegment(gaugeValue) {
      const manufacturer = getInputText('manufacturer');
      const coating = selectedBaseCoating();
      const isSsab = manufacturer === 'SSAB' || coating === 'Pural';
      if (isSsab) return 'PURALST25GA' + selectedColorCode();
      return cleanSkuPart(coating) + selectedFinishCode() + selectedGaugeCode(gaugeValue) + selectedColorCode();
    }

    function standingSeamPanelSku(product) {
      if (!isStandingSeamPanel(product)) return '';
      const lockCode = getInputText('lockType') === 'snap' ? 'S' : 'M';
      return 'SS' + lockCode + selectedMaterialSkuSegment(getInputText('gauge'));
    }

    function standingSeamFlashingPrefix(productName) {
      const name = String(productName || '').toLowerCase();
      if (name.includes('j flashing') && name.includes('perforated')) return 'JFP';
      if (name.includes('j flashing')) return 'JFL';
      if (name.includes('starter')) return 'ST';
      if (name.includes('gable')) return 'GA';
      if (name.includes('wall flashing')) return 'WA';
      if (name.includes('ridge')) return 'RI';
      if (name.includes('valley')) return 'VA';
      if (name.includes('step flashing')) return 'SF';
      if (name.includes('parapet')) return 'PA';
      return cleanSkuPart(productName).slice(0, 2);
    }

    function standingSeamFlashingSku(product) {
      if (!product || (product.system !== 'standing_seam' && product.system !== 'both')) return '';
      const name = String(product.name || '').toLowerCase();
      const isFlashing = name.includes('starter') || name.includes('gable') || name.includes('wall flashing') ||
        name.includes('step flashing') || name.includes('j flashing') || name.includes('ridge cap') ||
        name.includes('valley') || name.includes('parapet');
      if (!isFlashing) return '';
      return standingSeamFlashingPrefix(product.name) + '10' + selectedMaterialSkuSegment(getInputText('flashingGauge') || getInputText('gauge'));
    }

    function skuExistsInShopifyExportOrCache(sku) {
      const key = cleanSkuPart(sku);
      return !!(SHOPIFY_VARIANT_CACHE_BY_SKU[key] ||
        (typeof SHOPIFY_FALLBACK_VARIANTS_BY_SKU !== 'undefined' && SHOPIFY_FALLBACK_VARIANTS_BY_SKU[key]));
    }

    const ADDITIONAL_FIXED_SKU_BY_UUID = {
      '35-bathroom-metal-vent-auto': 'BMV',
      '34-master-flashing-auto': 'MSF',
      '364688c1-8378-4934-ad42-1b9d5bc48e8f': 'DRM360'
    };

    function titebondSealantSku() {
      const color = String(getInputText('color') || '').toLowerCase();

      if (color.includes('grey') || color.includes('gray')) return 'TBMSCGR';
      if (color.includes('brown')) return 'TBMSCBR';
      if (color.includes('clear')) return 'TBMSCCL';

      return 'TBMSCBL';
    }

    function fixedShopifySku(product) {
      if (!product) return '';
      if (product.uuid === '33-titebond-metal-sealant-cartridge') return titebondSealantSku();
      if (ADDITIONAL_FIXED_SKU_BY_UUID[product.uuid]) return ADDITIONAL_FIXED_SKU_BY_UUID[product.uuid];
      if (typeof SHOPIFY_FIXED_SKU_BY_UUID !== 'undefined' && SHOPIFY_FIXED_SKU_BY_UUID && SHOPIFY_FIXED_SKU_BY_UUID[product.uuid]) {
        return SHOPIFY_FIXED_SKU_BY_UUID[product.uuid];
      }
      return '';
    }

    function selectedShopifySku(product) {
      if (!product) return '';
      if (isStandingSeamPanel(product)) return standingSeamPanelSku(product);
      const flashingSku = standingSeamFlashingSku(product);
      if (flashingSku) {
        // Temporary compatibility for the current Shopify export: Starter Pural variants were exported as PURALTX,
        // while the standard calculator SKU format is PURALST. Once Shopify SKUs are corrected, this fallback is ignored.
        if (product.uuid === '58-starter-standing-seam' && flashingSku.indexOf('ST10PURALST25GA') === 0 && !skuExistsInShopifyExportOrCache(flashingSku)) {
          const exportedStarterPuralSku = flashingSku.replace('ST10PURALST25GA', 'ST10PURALTX25GA');
          if (skuExistsInShopifyExportOrCache(exportedStarterPuralSku)) return exportedStarterPuralSku;
        }
        return flashingSku;
      }
      const fixedSku = fixedShopifySku(product);
      if (fixedSku) return fixedSku;
      return product.sku || '';
    }

    function registerShopifyVariant(variant, handle) {
      if (!variant || !variant.sku) return;
      const sku = cleanSkuPart(variant.sku);
      SHOPIFY_VARIANT_CACHE_BY_SKU[sku] = {
        sku: sku,
        handle: handle || '',
        variantId: String(variant.id || ''),
        price: Number(variant.price || 0) / 100,
        available: variant.available !== false,
        title: variant.title || ''
      };
    }

    async function fetchShopifyProductByHandle(handle) {
      if (!handle) return null;
      if (SHOPIFY_PRODUCT_CACHE_BY_HANDLE[handle]) return SHOPIFY_PRODUCT_CACHE_BY_HANDLE[handle];
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) throw new Error('Could not load Shopify product: ' + handle);
      const product = await response.json();
      SHOPIFY_PRODUCT_CACHE_BY_HANDLE[handle] = product;
      (product.variants || []).forEach(function(variant) { registerShopifyVariant(variant, handle); });
      return product;
    }

    function allShopifyProductHandlesForCalculator() {
      const handles = new Set();
      if (typeof SHOPIFY_PRODUCT_HANDLES_BY_UUID !== 'undefined') {
        Object.keys(SHOPIFY_PRODUCT_HANDLES_BY_UUID).forEach(function(uuid) {
          if (SHOPIFY_PRODUCT_HANDLES_BY_UUID[uuid]) handles.add(SHOPIFY_PRODUCT_HANDLES_BY_UUID[uuid]);
        });
      }
      if (typeof SHOPIFY_FALLBACK_VARIANTS_BY_SKU !== 'undefined') {
        Object.keys(SHOPIFY_FALLBACK_VARIANTS_BY_SKU).forEach(function(sku) {
          const item = SHOPIFY_FALLBACK_VARIANTS_BY_SKU[sku];
          if (item && item.handle) handles.add(item.handle);
        });
      }
      return Array.from(handles);
    }

    async function loadShopifyCatalogPrices() {
      if (shopifyCatalogLoadStarted) return;
      shopifyCatalogLoadStarted = true;
      const message = document.getElementById('cartMessage');
      if (message) {
        message.style.display = 'block';
        message.className = 'cart-message';
        message.textContent = 'Loading live Shopify prices...';
      }
      try {
        await Promise.all(allShopifyProductHandlesForCalculator().map(function(handle) {
          return fetchShopifyProductByHandle(handle).catch(function(error) {
            console.warn(error.message);
            return null;
          });
        }));
        shopifyCatalogLoaded = true;
        if (message) {
          message.className = 'cart-message success';
          message.textContent = 'Live Shopify prices loaded.';
          window.setTimeout(function() { message.style.display = 'none'; }, 1800);
        }
        calculateMaterials();
      } catch (error) {
        console.warn(error.message);
        if (message) {
          message.className = 'cart-message error';
          message.textContent = 'Shopify prices could not be loaded. Calculator is using fallback prices.';
        }
        calculateMaterials();
      }
    }

    function shopifyVariantBySku(sku) {
      const key = cleanSkuPart(sku);
      if (SHOPIFY_VARIANT_CACHE_BY_SKU[key]) return SHOPIFY_VARIANT_CACHE_BY_SKU[key];
      if (typeof SHOPIFY_FALLBACK_VARIANTS_BY_SKU !== 'undefined' && SHOPIFY_FALLBACK_VARIANTS_BY_SKU[key]) {
        const fallback = SHOPIFY_FALLBACK_VARIANTS_BY_SKU[key];
        return {
          sku: key,
          handle: fallback.handle || '',
          variantId: String(fallback.variantId || ''),
          price: fallback.price !== undefined ? Number(fallback.price) : null,
          available: true,
          title: fallback.title || ''
        };
      }
      return null;
    }

    function shopifyPriceBySku(sku, fallbackPrice) {
      const variant = shopifyVariantBySku(sku);
      if (variant && typeof variant.price === 'number' && !Number.isNaN(variant.price) && variant.price > 0) return variant.price;
      return Number(fallbackPrice) || 0;
    }

    function shopifyVariantIdBySku(sku) {
      const variant = shopifyVariantBySku(sku);
      return variant && variant.variantId ? variant.variantId : '';
    }

    function selectedStandingSeamPanelPrice() {
      const manufacturer = getInputText('manufacturer');
      const coating = selectedBaseCoating();
      const finish = selectedEffectiveFinish();
      const gauge = getInputText('gauge');

      return STANDING_SEAM_PANEL_PRICES.find(function(rule) {
        const manufacturerMatches = rule.manufacturer === 'standard' ? manufacturer !== 'SSAB' : rule.manufacturer === manufacturer;
        const finishMatches = rule.finish === 'any' || rule.finish === finish;
        return manufacturerMatches && rule.coating === coating && finishMatches && rule.gauge === gauge;
      }) || null;
    }

    function trimPriceKey() {
      const manufacturer = getInputText('manufacturer');
      const gauge = getInputText('flashingGauge') || getInputText('gauge');
      const coating = selectedBaseCoating();
      const finish = selectedEffectiveFinish();

      if (manufacturer === 'SSAB' || coating === 'Pural') return 'Pural';
      if (coating === 'PVDF') return 'PVDF';
      return gauge + '_' + coating + '_' + finish;
    }

    // Step Flashing confirmed pricing rules:
    // SMP 26GA Glossy = 30; SMP 24GA Glossy = 34;
    // SMP 26GA Textured = 32; SMP 24GA Textured = 35;
    // PVDF 24GA Glossy = 39; SSAB Pural Standard = 40.
    function standingSeamTrimPrice(productName) {
      const key = trimPriceKey();
      const matrix = STANDING_SEAM_TRIM_PRICES[key] || STANDING_SEAM_TRIM_PRICES['26GA_SMP_Glossy'];
      const name = String(productName).toLowerCase();

      if (name.includes('starter') || name.includes('gable') || name.includes('wall flashing')) return matrix.eave;
      if (name.includes('step flashing')) return matrix.step;
      if (name.includes('perforated')) return matrix.perforatedJ;
      if (name.includes('j flashing')) return matrix.j;
      if (name.includes('ridge cap')) return matrix.ridge5;
      if (name.includes('valley') && name.includes('s lock')) return matrix.valleySlock;
      if (name.includes('valley cleat')) return matrix.valleyCleat;
      if (name.includes('valley')) return matrix.valley;
      return 0;
    }

    function fallbackCatalogUnitCost(product) {
      const name = String(product.name || '').toLowerCase();

      if (isMetalTilesSelected()) {
        const pricing = getMetalTilePricing();

        if (product.uuid === '56-metal-tiles') {
          return pricing.panels[metalTileStyleLabel()] || 0;
        }

        if (product.uuid === '57-starter-tiles') return pricing.trims.starter;
        if (product.uuid === '65-valley-tiles') return pricing.trims.valleys;
        if (product.uuid === '59-gable-tiles') return pricing.trims.gable;
        if (product.uuid === '62-ridge-cap-long-tiles') return pricing.trims.ridge;
        if (product.uuid === '66-wall-flashing-tiles') return pricing.trims.wall;
        if (product.uuid === '41-snow-holder-2lf') return pricing.trims.snowHolder;

        if (product.uuid === '39-metal-tile-membrane-auto') {
          const membrane = METAL_TILE_ACCESSORY_PRICES[getInputText('metalTileMembrane')];
          return membrane ? membrane.cost : 0;
        }

        if (product.uuid === '40-multipurpose-closure-strip') return METAL_TILE_ACCESSORY_PRICES.multipurposeClosure.cost;
        if (product.uuid === '43-vmax-tower-vent-black') return METAL_TILE_ACCESSORY_PRICES.vmaxTowerVent;
        if (product.uuid === '74-screws-tiles') return METAL_TILE_ACCESSORY_PRICES.screws250;
        if (product.uuid === '42-ridge-vent-tape') return METAL_TILE_ACCESSORY_PRICES.ridgeVentTape;
        if (product.uuid === '632a720f-80ea-4fa1-999f-2d3095bb9df8') return METAL_TILE_ACCESSORY_PRICES.strapping;
      }

      if (isStandingSeamPanel(product)) {
        const priceRule = selectedStandingSeamPanelPrice();
        return priceRule ? priceRule.price : Number(product.cost) || 0;
      }

      if (name.includes('underlayment') && name.includes('psu')) {
        return MEMBRANE_PRICES.standing_seam.psu30ht.standard;
      }

      if (name.includes('drainage')) {
        return MEMBRANE_PRICES.standing_seam.drainageMat.standard;
      }

      if (name.includes('synthetic underlayment') && product.system === 'metal_tiles') {
        return MEMBRANE_PRICES.metal_tiles.synthetic135.price;
      }

      if (name.includes('s-5! colorgard snow guards')) {
        if (getInputText('snowRetentionSpacing') === 'none') return 0;
        return getInputText('snowRetentionSpacing') === 'every_seam' ? ACCESSORY_PRICES.snowRetention.everySeamLF : ACCESSORY_PRICES.snowRetention.everyOtherSeamLF;
      }

      if (name.includes('screws')) {
        return ACCESSORY_PRICES.screws250;
      }

      if (name.includes('clips - mechanical')) {
        return ACCESSORY_PRICES.clipsMechanical;
      }

      if (name.includes('clips - snap')) {
        return ACCESSORY_PRICES.clipsSnapLock;
      }

      if (product.system === 'standing_seam' && (
        name.includes('starter') ||
        name.includes('gable') ||
        name.includes('wall flashing') ||
        name.includes('step flashing') ||
        name.includes('j flashing') ||
        name.includes('ridge cap') ||
        name.includes('valley')
      )) {
        return standingSeamTrimPrice(product.name);
      }

      if (name === 'delivery') {
        return getInputText('needDelivery') === 'outside_gta' ? 300 : 0;
      }

      return Number(product.cost) || 0;
    }

    function catalogUnitCost(product) {
      const fallbackPrice = fallbackCatalogUnitCost(product);
      const sku = selectedShopifySku(product);
      if (!sku) return fallbackPrice;
      return shopifyPriceBySku(sku, fallbackPrice);
    }

    function catalogPriceLabel(product) {
      const sku = selectedShopifySku(product);
      const variant = sku ? shopifyVariantBySku(sku) : null;
      if (variant && typeof variant.price === 'number' && variant.price > 0) {
        return 'Live Shopify price from SKU ' + sku;
      }
      if (variant && variant.variantId) {
        return 'Shopify variant mapped by SKU ' + sku + '; fallback price used until product JSON loads';
      }
      if (sku) return 'No Shopify variant found for SKU ' + sku + '; fallback price used';
      if (isStandingSeamPanel(product)) {
        const priceRule = selectedStandingSeamPanelPrice();
        return priceRule ? priceRule.label : 'Catalog default';
      }
      return 'Catalog default';
    }



    function shouldIncludeProduct(product) {
      if (!product.measurement || product.coverage <= 0) return false;
      if (product.uuid === '71-j-flashing-other') return false;

      const selectedSystem = getInputText('system') === 'all' ? 'standing_seam' : getInputText('system');
      if (product.system !== 'both' && product.system !== selectedSystem) return false;

      if (selectedSystem === 'metal_tiles') {
        const productName = String(product.name || '').toLowerCase();
        const hiddenForMetalTiles = [
          '63-ridge-cap-short-tiles',
          '67-j-flashing-perforated',
          '68-j-flashing-hips',
          '75-screws-standing-seam',
          '76-clips-mechanical-lock',
          '76-clips-snap-lock',
          '83-ht-underlayment',
          '364688c1-8378-4934-ad42-1b9d5bc48e8f',
          '82-synthetic-underlayment-tiles',
          '31-synthetic-underlayment-tiles'
        ];

        if (hiddenForMetalTiles.includes(product.uuid)) return false;
        if (productName.includes('synthetic underlayment')) return false;
        if (productName.includes('underlayment') && product.system === 'metal_tiles') return false;

        if (product.uuid === '39-metal-tile-membrane-auto' || productName === 'metal tile membrane') {
          return getInputText('metalTileMembrane') !== 'none';
        }

        if (product.uuid === '40-multipurpose-closure-strip' && getInputText('multipurposeClosure') === 'none') return false;
        if (product.uuid === '43-vmax-tower-vent-black' && getInputNumber('vmaxTowerVentQty') <= 0) return false;
      }

      if (product.lockType && product.lockType !== getInputText('lockType')) return false;

      if (product.itemType !== 'material') return false;

      return true;
    }

    function measurementValue(measurement) {
      if (!measurement) return 0;
      return measurement.split(',').map(function(part) { return part.trim(); }).reduce(function(total, token) {
        if (token === 'TOTAL_PITCH_AREA_SQUARES') return total + getInputNumber('area') / 100;
        if (token === 'TOTAL_FLAT_AREA_SQUARES') return total + getInputNumber('flatArea') / 100;
        if (token === 'DELIVERY') return total + (getInputText('needDelivery') === 'outside_gta' ? 1 : 0);
        if (token === 'VMAX_TOWER_VENT') return total + getInputNumber('vmaxTowerVentQty');
        if (token === 'EAVES_LENGTH') return total + effectiveMeasuredLength('eaves');
        if (token === 'RIDGES_LENGTH') return total + effectiveMeasuredLength('ridges');
        if (token === 'MULTIPURPOSE_CLOSURE') {
          const ridges = effectiveMeasuredLength('ridges');
          const hips = getInputNumber('hips');
          const valleys = getInputNumber('valleys');
          const rakes = getInputNumber('rakes');
          const walls = getInputNumber('walls');
          const eaves = effectiveMeasuredLength('eaves');
          const steps = getInputNumber('steps');
          const closureMode = getInputText('multipurposeClosure');
          if (closureMode === 'none') return total;
          if (closureMode === 'ridge_hip_valley') return total + (((ridges * 2 + hips * 2 + valleys * 2) * 12) / 39);
          return total + ((((ridges * 2 + hips * 2 + valleys * 2) + rakes + walls + eaves + steps) * 12) / 39);
        }
        const inputId = MEASUREMENT_INPUTS[token];
        return total + (inputId ? getInputNumber(inputId) : 0);
      }, 0);
    }


    function lockTypeLabel() {
      return getInputText('lockType') === 'snap' ? 'Snap Lock 1.5 inch' : 'Mechanical Lock 1.5 inch';
    }

    function selectedPanelsFeature() {
      return getInputText('panelsFeature') || 'Plain panel';
    }

    function materialDetailsForGauge(gauge) {
      return getInputText('manufacturer') + ' | ' + gauge + ' | ' + getInputText('coating') + ' | ' + getInputText('color') + ' | ' + getInputText('finish');
    }

    function panelMaterialDetails() {
      return materialDetailsForGauge(getInputText('gauge'));
    }

    function flashingMaterialDetails() {
      return materialDetailsForGauge(getInputText('flashingGauge') || getInputText('gauge'));
    }

    function displayMaterialName(product) {
      const name = String(product.name || '').toLowerCase();
      if (isStandingSeamPanel(product)) {
        return 'Standing Seam - ' + lockTypeLabel() + ' - (' + panelMaterialDetails() + ')';
      }
      if (product.system === 'standing_seam') {
        const details = ' - (' + flashingMaterialDetails() + ')';
        if (name === 'starter') return 'Starter - 10ln. ft.' + details;
        if (name === 'gable') return 'Gable(Rake) - 10ln. ft.' + details;
        if (name === 'wall flashing') return 'Wall flashing - 10ln. ft.' + details;
        if (name === 'ridge cap') return 'Ridge capping - 10ln. ft.' + details;
        if (name === 'valley') return 'Valleys - 10ln. ft.' + details;
        if (name === 'step flashing') return 'Step Flashing - 10ln. ft.' + details;
        if (name.includes('j flashing - perforated')) return 'J Flashing - Perforated - 10ln. ft. - (' + flashingMaterialDetails() + ')';
        if (name.includes('j flashing - plain')) return 'J Flashing - Plain - 10ln. ft. - (' + flashingMaterialDetails() + ')';
      }
      if (isMetalTilePanel(product)) return 'Metal Tiles';
      if (product.uuid === '57-starter-tiles') return 'Starter';
      if (product.uuid === '59-gable-tiles') return 'Gable(Rake)';
      if (product.uuid === '66-wall-flashing-tiles') return 'Wall flashing';
      if (product.uuid === '65-valley-tiles') return 'Valleys';
      if (product.uuid === '62-ridge-cap-long-tiles') return getInputText('manufacturer').includes('Finland') ? 'Ridge capping - 7ln. ft.' : 'Ridge capping - 10ln. ft.';
      if (product.uuid === '41-snow-holder-2lf') {
        return getInputText('manufacturer').includes('Finland')
          ? 'Snow Holder (2 LF)'
          : 'Snow Holder (10 LF)';
      }

      if (product.uuid === '74-screws-tiles') return 'Screws 4.8x35 (steel gasket) - 250 EA';
      if (product.uuid === '39-metal-tile-membrane-auto') {
        const membrane = METAL_TILE_ACCESSORY_PRICES[getInputText('metalTileMembrane')];
        return membrane ? membrane.name : 'Metal Tile Membrane';
      }
      if (product.uuid === '37-flat-roof-base') return 'Base - Flat Roof Membrane - 86 sq.ft. per roll';
      if (product.uuid === '38-flat-roof-cap') return 'Cap - Flat Roof Membrane - 72 sq.ft. per roll';
      if (product.uuid === 'e7e26415-d47e-462d-b582-15f19b2e14b8') return 'Parapet Capping - 10ln. ft.';
      return product.name;
    }

    function cloneMaterials(materials) {
      return JSON.parse(JSON.stringify(materials || []));
    }

    function materialListsMatch(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;

      return a.every(function(item, index) {
        const other = b[index];
        if (!other) return false;

        return item.uuid === other.uuid &&
          Number(item.qty) === Number(other.qty) &&
          Number(item.unitCost) === Number(other.unitCost) &&
          String(item.name) === String(other.name);
      });
    }

    function materialChangeKey(item) {
      return String(item.uuid || item.sku || item.name || '');
    }

    function calculateChangedMaterialKeys(previousMaterials, nextMaterials) {
      const previousMap = new Map();
      (previousMaterials || []).forEach(function(item) {
        previousMap.set(materialChangeKey(item), item);
      });

      const changed = new Set();

      (nextMaterials || []).forEach(function(item) {
        const key = materialChangeKey(item);
        const previous = previousMap.get(key);

        if (!previous) {
          changed.add(key);
          return;
        }

        if (
          Number(previous.qty) !== Number(item.qty) ||
          Number(previous.unitCost) !== Number(item.unitCost) ||
          Number(previous.totalCost) !== Number(item.totalCost) ||
          String(previous.name) !== String(item.name) ||
          String(previous.unit) !== String(item.unit)
        ) {
          changed.add(key);
        }
      });

      return changed;
    }

    function refreshManualEditStatus() {
      if (materialsManuallyEdited && materialListsMatch(currentMaterials, recommendedMaterialsSnapshot)) {
        materialsManuallyEdited = false;
        removedMaterialsHistory = [];
      }
      updateInputLockState();
    }

    function updateMaterialsEditUI() {
      const status = document.getElementById('materialsListStatus');
      if (status) {
        status.textContent = materialsManuallyEdited ? 'Manually Edited List' : 'Suggested List';
        status.classList.toggle('edited', materialsManuallyEdited);
      }

      const restoreRemovedButton = document.getElementById('restoreRemovedItemBtn');
      if (restoreRemovedButton) {
        restoreRemovedButton.classList.toggle('visible', removedMaterialsHistory.length > 0);
      }
    }

    function updateInputLockState() {
      const wrapper = document.getElementById('inputLockWrap');
      if (!wrapper) return;
      wrapper.classList.toggle('is-locked', materialsManuallyEdited);
      wrapper.querySelectorAll('input, select, button').forEach(function(control) {
        if (control.id !== 'restoreSuggestedListBtn') {
          control.disabled = materialsManuallyEdited;
        }
      });
      updateMaterialsEditUI();
    }

    function markMaterialsEdited() {
      if (!materialsManuallyEdited) {
        recommendedMaterialsSnapshot = cloneMaterials(currentMaterials);
        materialsManuallyEdited = true;
      }
      updateInputLockState();
    }

    function restoreSuggestedMaterials() {
      currentMaterials = cloneMaterials(recommendedMaterialsSnapshot);
      materialsManuallyEdited = false;
      removedMaterialsHistory = [];
      updateInputLockState();
      renderMaterials();
      updateDisplayedTotals();
    }

    function updateMaterialQty(index, value) {
      const item = currentMaterials[index];
      if (!item) return;
      markMaterialsEdited();
      const qty = Math.ceil(Math.max(parseFloat(value) || 0, 0));
      item.qty = qty;
      item.totalCost = qty * item.unitCost;
      refreshManualEditStatus();
      renderMaterials();
      updateDisplayedTotals();
    }

    function removeMaterial(index) {
      if (!currentMaterials[index]) return;
      markMaterialsEdited();
      removedMaterialsHistory.push({
        item: cloneMaterials([currentMaterials[index]])[0],
        index: index
      });
      currentMaterials.splice(index, 1);
      renderMaterials();
      updateDisplayedTotals();
      updateMaterialsEditUI();
    }

    function restoreLastRemovedItem() {
      if (!removedMaterialsHistory.length) return;

      const removed = removedMaterialsHistory.pop();
      if (!removed || !removed.item) return;

      const restoreIndex = Math.min(removed.index, currentMaterials.length);
      currentMaterials.splice(restoreIndex, 0, cloneMaterials([removed.item])[0]);

      refreshManualEditStatus();
      renderMaterials();
      updateDisplayedTotals();
      updateMaterialsEditUI();
    }

    function updateDisplayedTotals() {
      const subtotal = currentMaterials.reduce(function(sum, item) { return sum + item.totalCost; }, 0);
      const hst = subtotal * 0.13;
      const totalWithTax = subtotal + hst;
      document.getElementById('subtotalAmount').textContent = money(subtotal);
      document.getElementById('hstAmount').textContent = money(hst);
      document.getElementById('totalWithTaxAmount').textContent = money(totalWithTax);
    }

    function materialSortOrder(item) {
      const uuid = item.uuid;
      const name = String(item.name || '').toLowerCase();

      if (item.system === 'metal_tiles' || uuid === '39-metal-tile-membrane-auto' || uuid === '40-multipurpose-closure-strip' || uuid === '43-vmax-tower-vent-black') {
        if (uuid === '56-metal-tiles') return 10;
        if (uuid === '57-starter-tiles') return 20;
        if (uuid === '65-valley-tiles') return 30;
        if (uuid === '59-gable-tiles') return 40;
        if (uuid === '62-ridge-cap-long-tiles') return 50;
        if (uuid === '66-wall-flashing-tiles') return 60;
        if (uuid === '41-snow-holder-2lf') return 70;
        if (uuid === '632a720f-80ea-4fa1-999f-2d3095bb9df8') return 80;
        if (uuid === '74-screws-tiles') return 90;
        if (uuid === '39-metal-tile-membrane-auto') return 100;
        if (uuid === '42-ridge-vent-tape') return 110;
        if (uuid === '34-master-flashing-auto') return 120;
        if (uuid === '35-bathroom-metal-vent-auto') return 130;
        if (uuid === '33-titebond-metal-sealant-cartridge') return 140;
        if (uuid === '40-multipurpose-closure-strip') return 150;
        if (uuid === '43-vmax-tower-vent-black') return 160;
        if (uuid === '36-delivery') return 170;
        return 800;
      }

      if (uuid === 'c3423c66-75e5-4fa2-8142-73f5b5768a33' || uuid === '66f363c8-32e1-40b4-a36d-a34cd7332af7' || uuid === '54-standing-seam-greencoat' || isStandingSeamPanel(item)) return 10;
      if (uuid === '58-starter-standing-seam') return 20;
      if (uuid === '60-gable-standing-seam') return 30;
      if (uuid === '70-wall-flashing') return 40;
      if (uuid === '61-ridge-cap-standing-seam') return 50;
      if (uuid === '64-valley-standing-seam') return 60;
      if (uuid === '72-step-flashing') return 70;
      if (uuid === '67-j-flashing-perforated') return 80;
      if (uuid === '68-j-flashing-hips') return 90;
      if (name.includes('screws')) return 100;
      if (name.includes('clips')) return 110;
      if (name.includes('underlayment')) return 120;
      if (name.includes('drainage')) return 125;
      if (name.includes('titebond')) return 130;
      return 900;
    }
    function calculateProduct(product) {
      const base = measurementValue(product.measurement);
      const selectedWasteFactor = getInputNumber('wasteFactor');
      const productName = String(product.name || '').toLowerCase();

      let qtyRaw = (base / Number(product.coverage)) * (1 + selectedWasteFactor / 100);
      let qty = roundUp(qtyRaw);

      if (product.uuid === '37-flat-roof-base') {
        qtyRaw = (getInputNumber('flatArea') * (1 + getFlatRoofSlopeNumber() / 200)) / 86;
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '38-flat-roof-cap') {
        qtyRaw = (getInputNumber('flatArea') * (1 + getFlatRoofSlopeNumber() / 170)) / 72;
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '56-metal-tiles') {
        qtyRaw = (getInputNumber('area') / 28) * (1 + selectedWasteFactor / 100);
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '39-metal-tile-membrane-auto') {
        qtyRaw = getInputNumber('area') / 800;
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '40-multipurpose-closure-strip') {
        qtyRaw = measurementValue('MULTIPURPOSE_CLOSURE');
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '41-snow-holder-2lf') {
        const wasteMultiplier = 1 + selectedWasteFactor / 100;

        if (getInputText('manufacturer').includes('Finland')) {
          qtyRaw = (effectiveMeasuredLength('eaves') / 4) * wasteMultiplier;
        } else {
          qtyRaw = ((effectiveMeasuredLength('eaves') / 10) / 2) * wasteMultiplier;
        }

        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '42-ridge-vent-tape') {
        qtyRaw = effectiveMeasuredLength('ridges') / 15;
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '43-vmax-tower-vent-black') {
        qtyRaw = getInputNumber('vmaxTowerVentQty');
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '62-ridge-cap-long-tiles' && getInputText('manufacturer').includes('Finland')) {
        qtyRaw = (measurementValue(product.measurement) / 7) * (1 + selectedWasteFactor / 100);
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === '61-ridge-cap-standing-seam') {
        const ridgeAndHip = effectiveMeasuredLength('ridges') + getInputNumber('hips');
        qtyRaw = (ridgeAndHip / 10) * (1 + selectedWasteFactor / 100);
        qty = roundUp(qtyRaw);
      }

      if (product.uuid === 'e7e26415-d47e-462d-b582-15f19b2e14b8') {
        qtyRaw = (getInputNumber('parapet') / 10) * (1 + selectedWasteFactor / 100);
        qty = roundUp(qtyRaw);
      }

      if (productName === 'delivery') {
        qty = getInputText('needDelivery') === 'outside_gta' ? 1 : 0;
      }

      if (product.uuid === '74-screws-tiles') {
        qty = roundUp(getInputNumber('area') / 250);
      } else if (productName.includes('screws')) {
        qty = roundUp(qty / 250);
      }

      if (productName.includes('clips - mechanical')) {
        qty = roundUp(qty / 1000);
      }

      if (productName.includes('clips - snap')) {
        qty = roundUp(qty / 250);
      }

      if (productName.includes('s-5! colorgard snow guards') && getInputText('snowRetentionSpacing') === 'none') {
        qty = 0;
      }

      let unitCost = catalogUnitCost(product);

      if (productName.includes('clips - mechanical')) {
        unitCost = ACCESSORY_PRICES.clipsMechanicalBox1000;
      }

      if (productName.includes('clips - snap')) {
        unitCost = ACCESSORY_PRICES.clipsSnapLockBox250;
      }

      if (productName.includes('underlayment') && productName.includes('psu')) {
        if (qty > MEMBRANE_PRICES.standing_seam.psu30ht.skidThreshold) {
          unitCost = MEMBRANE_PRICES.standing_seam.psu30ht.skid;
        }
      }

      const skipProductionBreakdown = product.uuid === '67-j-flashing-perforated' || product.uuid === '68-j-flashing-hips';
      let flashingBreakdown;
      let extraBreakdownNote = '';
      if (!skipProductionBreakdown && !isMetalTilesSelected() && product.system === 'standing_seam') {
        const measurementTokens = product.measurement ? String(product.measurement).split(',').map(function(part) { return part.trim(); }) : [];
        if (measurementTokens.includes('EAVES_LENGTH')) flashingBreakdown = proPitchBreakdown('eaves', product.coverage);
        if (measurementTokens.includes('RIDGES_LENGTH')) flashingBreakdown = proPitchBreakdown('ridges', product.coverage);
        if (product.uuid === '61-ridge-cap-standing-seam') {
          flashingBreakdown = proPitchBreakdown('ridges', 10);
          if (getInputNumber('hips') > 0) extraBreakdownNote = 'Hips included separately in total qty: ' + getInputNumber('hips').toFixed(2) + ' ft -> ' + roundUp(getInputNumber('hips') / 10) + ' pcs.';
        }
      }

      const resolvedShopifySku = selectedShopifySku(product);
      const resolvedShopifyVariantId = shopifyVariantIdBySku(resolvedShopifySku) || SHOPIFY_VARIANTS[product.uuid] || '';

      return {
        sku: resolvedShopifySku || product.sku || '',
        uuid: product.uuid,
        variantId: resolvedShopifyVariantId,
        name: displayMaterialName(product),
        qty: qty,
        unit: product.uuid === '74-screws-tiles' ? 'Box (250 pcs)' : productName.includes('screws') ? 'Box (250 pcs)' : productName.includes('clips - mechanical') ? 'Box (1000 pcs)' : productName.includes('clips - snap') ? 'Box (250 pcs)' : product.unit || 'Unit',
        unitCost: unitCost,
        totalCost: qty * unitCost,
        itemType: product.itemType,
        measurement: product.measurement,
        coverage: product.coverage,
        system: product.system,
        flashingBreakdown: flashingBreakdown,
        extraBreakdownNote: extraBreakdownNote,
        note: product.uuid === '37-flat-roof-base'
          ? 'Measurement: Total Flat Area; flat area: ' + getInputNumber('flatArea').toFixed(2) + '; flat roof slope: ' + getInputText('flatRoofSlope') + '; formula: flat area x (1 + slope / 200) / 86; price: $95 per roll.'
          : product.uuid === '38-flat-roof-cap'
            ? 'Measurement: Total Flat Area; flat area: ' + getInputNumber('flatArea').toFixed(2) + '; flat roof slope: ' + getInputText('flatRoofSlope') + '; formula: flat area x (1 + slope / 170) / 72; price: $89 per roll.'
            : 'Measurement: ' + product.measurement + '; base: ' + base.toFixed(2) + '; coverage: ' + product.coverage + '; waste factor: ' + selectedWasteFactor + '%. Price rule: ' + catalogPriceLabel(product) + '.'
      };
    }

    function calculateMaterials() {
      if (materialsManuallyEdited) {
        renderMaterials();
        updateDisplayedTotals();
        return currentMaterials;
      }

      const previousMaterials = cloneMaterials(currentMaterials);

      const nextMaterials = PRODUCT_CATALOG
        .filter(shouldIncludeProduct)
        .map(calculateProduct)
        .filter(function(item) { return item.qty > 0; })
        .sort(function(a, b) { return materialSortOrder(a) - materialSortOrder(b); });

      changedMaterialKeys = calculateChangedMaterialKeys(previousMaterials, nextMaterials);
      currentMaterials = nextMaterials;

      recommendedMaterialsSnapshot = cloneMaterials(currentMaterials);
      removedMaterialsHistory = [];
      updateInputLockState();

      const selected = getInputText('system');
      const systemLabel = selected === 'standing_seam' ? 'Standing Seam' : selected === 'metal_tiles' ? 'Metal Tiles' : 'All';
      const materialDetails = isMetalTilesSelected()
        ? [
          getInputText('manufacturer') + ' | ' + getInputText('coating') + ' | ' + getInputText('color') + ' | ' + getInputText('finish'),
          'Panels thickness - ' + getInputText('gauge'),
          'Metal tiles style - ' + metalTileStyleLabel()
        ].join('\n')
        : [
          getInputText('manufacturer') + ' | ' + getInputText('coating') + ' | ' + getInputText('color') + ' | ' + getInputText('finish'),
          'Panels thickness - ' + getInputText('gauge'),
          'Flashings thickness - ' + (getInputText('flashingGauge') || getInputText('gauge'))
        ].join('\n');

      document.getElementById('sumSystem').textContent = systemLabel;
      document.getElementById('sumMaterialDetails').textContent = materialDetails;
      updateDisplayedTotals();
      renderMaterials();
      return currentMaterials;
    }

    function createCell(text, className) { const td = document.createElement('td'); if (className) td.className = className; td.textContent = text; return td; }
    function createTag(text) { const span = document.createElement('span'); span.className = 'tag'; span.textContent = text; return span; }

    

/* =========================================================
   PRODUCT HOVER PREVIEW FEATURE
   ========================================================= */

let productHoverCardEl = null;
let productHoverHideTimer = null;

function stripHtml(value) {
  return String(value || '').replace(/<[^>]*>/g, '').trim();
}

function ensureProductHoverCard() {
  if (productHoverCardEl) return productHoverCardEl;

  productHoverCardEl = document.createElement('div');
  productHoverCardEl.className = 'product-hover-card';

  document.body.appendChild(productHoverCardEl);

  return productHoverCardEl;
}

async function showProductHoverCard(event, item) {
  clearTimeout(productHoverHideTimer);

  if (!item || !item.sku) return;

  const variant = shopifyVariantBySku(item.sku);

  if (!variant || !variant.handle) return;

  const product = await fetchShopifyProductByHandle(variant.handle).catch(function() {
    return null;
  });

  if (!product) return;

  const card = ensureProductHoverCard();

  const image =
    product.featured_image ||
    (product.images && product.images.length ? product.images[0] : '');

  const description = stripHtml(product.description).slice(0, 240);

  card.innerHTML =
    '<div class="product-hover-image-wrap">' +
      (image
        ? '<img class="product-hover-image" src="' + image + '" alt="' + product.title + '" />'
        : '') +
    '</div>' +
    '<div class="product-hover-content">' +
      '<div class="product-hover-title-text">' + product.title + '</div>' +
      '<div class="product-hover-description">' +
        (description || 'No product description available.') +
      '</div>' +
      '<div class="product-hover-meta">' +
        '<span class="product-hover-badge">SKU: ' + item.sku + '</span>' +
        '<span class="product-hover-badge">' + item.unit + '</span>' +
      '</div>' +
    '</div>';

  const offsetX = 18;
  const offsetY = 18;

  let left = event.clientX + offsetX;
  let top = event.clientY + offsetY;

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  card.style.display = 'block';

  const rect = card.getBoundingClientRect();

  if (left + rect.width > viewportWidth - 12) {
    left = viewportWidth - rect.width - 12;
  }

  if (top + rect.height > viewportHeight - 12) {
    top = viewportHeight - rect.height - 12;
  }

  card.style.left = left + 'px';
  card.style.top = top + 'px';
}

function hideProductHoverCard() {
  productHoverHideTimer = setTimeout(function() {
    if (productHoverCardEl) {
      productHoverCardEl.style.display = 'none';
    }
  }, 90);
}


function renderMaterials() {
      const body = document.getElementById('materialsBody');
      body.textContent = '';

      const existingWarning = document.getElementById('manualEditWarning');
      if (existingWarning) existingWarning.remove();

      if (materialsManuallyEdited) {
        const tableWrap = document.querySelector('.table-wrap');
        if (tableWrap) {
          const warning = document.createElement('div');
          warning.id = 'manualEditWarning';
          warning.className = 'edit-warning';
          warning.textContent = 'The suggested material list has been manually edited. The customer is responsible for the final ordered materials and quantities.';
          tableWrap.parentNode.insertBefore(warning, tableWrap);
        }
      }

      currentMaterials.forEach(function(item, index) {
        const row = document.createElement('tr');
        if (changedMaterialKeys.has(materialChangeKey(item))) {
          row.className = 'material-row-changed';
        }
        const materialCell = document.createElement('td');
        const strong = document.createElement('strong');
        strong.className = 'material-hover-title';
        strong.textContent = item.name;

        strong.addEventListener('mouseenter', function(event) {
          showProductHoverCard(event, item);
        });

        strong.addEventListener('mousemove', function(event) {
          if (!productHoverCardEl || productHoverCardEl.style.display !== 'block') return;

          let left = event.clientX + 18;
          let top = event.clientY + 18;

          const rect = productHoverCardEl.getBoundingClientRect();

          if (left + rect.width > window.innerWidth - 12) {
            left = window.innerWidth - rect.width - 12;
          }

          if (top + rect.height > window.innerHeight - 12) {
            top = window.innerHeight - rect.height - 12;
          }

          productHoverCardEl.style.left = left + 'px';
          productHoverCardEl.style.top = top + 'px';
        });

        strong.addEventListener('mouseleave', hideProductHoverCard);

        materialCell.appendChild(strong);

        if (String(item.name).toLowerCase().includes('standing seam -')) {
          const featureNote = document.createElement('div');
          featureNote.className = 'material-subnote';
          featureNote.textContent = 'Panels feature: ' + selectedPanelsFeature();
          materialCell.appendChild(featureNote);
        }

        const breakdownLines = formatFlashingBreakdownLines(item);
        if (breakdownLines.length) {
          const list = document.createElement('ul');
          list.className = 'flashing-breakdown-list';
          breakdownLines.forEach(function(line) {
            const li = document.createElement('li');
            li.textContent = line;
            list.appendChild(li);
          });
          materialCell.appendChild(list);
        }

        const qtyCell = document.createElement('td');
        const qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.min = '0';
        qtyInput.step = '1';
        qtyInput.className = 'qty-input';
        qtyInput.value = String(item.qty);
        qtyInput.setAttribute('aria-label', 'Edit quantity for ' + item.name);
        qtyInput.addEventListener('keydown', function(event) {
          if (['e', 'E', '+', '-', '.'].includes(event.key)) event.preventDefault();
        });
        qtyInput.addEventListener('change', function() {
          updateMaterialQty(index, qtyInput.value);
        });
        qtyCell.appendChild(qtyInput);

        const actionCell = document.createElement('td');
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'remove-row-btn';
        removeButton.textContent = 'Remove';
        removeButton.addEventListener('click', function() {
          removeMaterial(index);
        });
        actionCell.appendChild(removeButton);

        row.appendChild(materialCell);
        row.appendChild(qtyCell);
        row.appendChild(createCell(item.unit, ''));
        row.appendChild(createCell(money(item.unitCost), 'money'));
        row.appendChild(createCell(money(item.totalCost), 'money'));
        row.appendChild(actionCell);
        body.appendChild(row);
      });

      if (changedMaterialKeys.size) {
        window.setTimeout(function() {
          changedMaterialKeys = new Set();
        }, 1700);
      }
    }

    async function addAllToShopifyCart() {
      if (!shopifyCatalogLoaded) await loadShopifyCatalogPrices();
      if (!currentMaterials.length) calculateMaterials();
      const cartMessage = document.getElementById('cartMessage');
      cartMessage.style.display = 'block';
      cartMessage.className = 'cart-message';
      cartMessage.textContent = 'Adding mapped catalog items to cart...';

      const items = currentMaterials.filter(function(item) { return item.variantId; }).map(function(item) {
        return { id: Number(item.variantId), quantity: Number(item.qty), properties: { Material: item.name, SKU: item.sku, Unit: item.unit, Measurement: item.measurement, Coverage: String(item.coverage), Manufacturer: getInputText('manufacturer'), Panel_Gauge: getInputText('gauge'), Flashing_Gauge: getInputText('flashingGauge'), Coating: getInputText('coating'), Finish: getInputText('finish'), Color: getInputText('color'), Lock_Type: getInputText('lockType'), Waste_Factor: getInputText('wasteFactor'), Flat_Roof_Slope: getInputText('flatRoofSlope'), Project_Name: getInputText('projectName'), Project_Address: getInputText('projectAddress'), Delivery: getInputText('needDelivery'), Delivery_Note: getInputText('deliveryNote') } };
      });

      if (!items.length) {
        cartMessage.className = 'cart-message error';
        cartMessage.textContent = 'No Shopify variant IDs are mapped yet. Check Shopify SKUs and SHOPIFY_FALLBACK_VARIANTS_BY_SKU.';
        return;
      }

      try {
        const response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items:items }) });
        if (!response.ok) {
          const data = await response.json().catch(function() { return {}; });
          throw new Error(data.description || 'Shopify cart request failed.');
        }
        cartMessage.className = 'cart-message success';
        cartMessage.textContent = 'Mapped catalog items were added to cart.';
        window.setTimeout(function() { window.location.href = '/cart'; }, 900);
      } catch (error) {
        cartMessage.className = 'cart-message error';
        cartMessage.textContent = 'Could not add materials to cart: ' + error.message;
      }
    }


    function pdfSafeFileName(value) {
      const cleaned = String(value || 'roof-materials-list')
        .trim()
        .replace(/[^a-z0-9\-_]+/gi, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      return cleaned || 'roof-materials-list';
    }

    function materialNameForPDF(item) {
      const isStandingSeamPanel = String(item.name || '').toLowerCase().includes('standing seam -');
      const parts = [isStandingSeamPanel ? item.name + '\nPanels feature: ' + selectedPanelsFeature() : item.name];
      const breakdownLines = formatFlashingBreakdownLines(item);
      if (breakdownLines.length) {
        parts.push('Production breakdown:');
        breakdownLines.forEach(function(line) { parts.push('- ' + line); });
      }
      return parts.join('\n');
    }

    function downloadPDF() {
      if (!currentMaterials.length) calculateMaterials();

      if (!window.jspdf || !window.jspdf.jsPDF) {
        alert('PDF library is not loaded. Please check your internet connection and try again.');
        return;
      }

      const doc = new window.jspdf.jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: 'letter'
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 28;
      const footerHeight = 92;
      const footerTopY = pageHeight - footerHeight + 10;
      const footerBottomY = pageHeight - 10;
      const usableBottomY = pageHeight - footerHeight - 8;
      const projectName = getInputText('projectName') || 'Roof Materials List';
      const projectAddress = getInputText('projectAddress') || '-';
      const generatedAt = new Date();
      const selected = getInputText('system');
      const systemLabel = selected === 'standing_seam' ? 'Standing Seam' : selected === 'metal_tiles' ? 'Metal Tiles' : 'All';
      const subtotal = currentMaterials.reduce(function(sum, item) { return sum + item.totalCost; }, 0);
      const hst = subtotal * 0.13;
      const totalWithTax = subtotal + hst;

      const generalDisclaimer = 'The customer is responsible for the accuracy of all entered input data. All suppliers except SSAB recommend ordering extra material because colour shade and texture grain may vary between production batches.';

      const manualEditDisclaimer = materialsManuallyEdited
        ? 'The suggested material list was manually modified by the customer. The customer accepts full responsibility for the correctness, completeness, and suitability of the final ordered materials and quantities.'
        : '';

      const deliverySelected = getInputText('needDelivery') !== 'no';

      const logisticsDisclaimer = deliverySelected
        ? 'Customer is responsible for unloading and providing enough space to safely place the materials on site.'
        : 'Customer is fully responsible for safe transportation, loading, unloading, securing, tarping, and handling of all materials after pickup. The customer must ensure that all materials are properly fastened, supported, and protected during transportation in accordance with all applicable laws, transportation regulations, and safety requirements. Monarchy Roofing is not responsible for any damage, deformation, scratches, bending, shifting, loss, water exposure, road debris impact, improper strapping, insufficient trailer or vehicle capacity, or any other issues caused during transport or handling by the customer or third parties. The customer assumes full responsibility for verifying that the trailer, pickup truck, roof rack, straps, tarps, and all transportation equipment are suitable and safely secured for the load being transported.';

      const disclaimerText = [generalDisclaimer, manualEditDisclaimer, logisticsDisclaimer]
        .filter(function(line) { return line; })
        .join(' ');

      const tableWidth = pageWidth - margin * 2;

      function drawPdfFooter(pageNumber, totalPages) {
        const currentTextColor = doc.getTextColor ? doc.getTextColor() : '#172033';
        doc.setDrawColor(223, 227, 234);
        doc.setLineWidth(0.4);
        doc.line(margin, footerTopY - 6, pageWidth - margin, footerTopY - 6);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6.2);
        doc.setTextColor(75, 85, 99);
        const disclaimerLines = doc.splitTextToSize(disclaimerText, tableWidth);
        doc.text(disclaimerLines, margin, footerTopY, { lineHeightFactor: 1.12 });

        doc.setFontSize(6.5);
        doc.setTextColor(107, 114, 128);
        doc.text('Generated at: ' + formatDateTime(generatedAt), margin, footerBottomY);
        doc.text('Page ' + pageNumber + ' of ' + totalPages, pageWidth - margin, footerBottomY, { align: 'right' });
        doc.setTextColor(currentTextColor);
      }

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.text('Roof Materials List', margin, 32);

      doc.setFontSize(10);
      doc.text('Quote Date: ' + formatDateOnly(generatedAt), pageWidth / 2, 32, { align: 'center' });

      doc.setFontSize(12);
      doc.text('Quote ID: ' + quoteId, pageWidth - margin, 32, { align: 'right' });

      const leftLabelX = margin;
      const leftValueX = 122;
      const rightLabelX = pageWidth / 2 + 10;
      const rightValueX = rightLabelX + 104;
      const headerStartY = 53;
      const rowGap = 11;

      const leftHeader = isMetalTilesSelected()
        ? [
          ['Project:', projectName],
          ['Project Address:', projectAddress],
          ['System:', systemLabel],
          ['Metal Tiles Style:', metalTileStyleLabel()],
          ['Waste Factor:', getInputText('wasteFactor') + '%'],
          ['Flat Roof Slope:', getInputText('flatRoofSlope')]
        ]
        : [
          ['Project:', projectName],
          ['Project Address:', projectAddress],
          ['System:', systemLabel],
          ['Lock Type:', lockTypeLabel()],
          ['Panels Feature:', selectedPanelsFeature()],
          ['Waste Factor:', getInputText('wasteFactor') + '%'],
          ['Flat Roof Slope:', getInputText('flatRoofSlope')]
        ];

      const rightHeader = [
        ['Manufacturer:', getInputText('manufacturer')],
        ['Panel Gauge:', getInputText('gauge')],
        ['Flashing Gauge:', getInputText('flashingGauge') || getInputText('gauge')],
        ['Coating:', getInputText('coating')],
        ['Color:', getInputText('color')],
        ['Finish:', getInputText('finish')]
      ];

      doc.setFontSize(8.5);
      leftHeader.forEach(function(row, index) {
        const y = headerStartY + index * rowGap;
        doc.setFont('helvetica', 'bold');
        doc.text(row[0], leftLabelX, y);
        doc.setFont('helvetica', 'normal');
        doc.text(String(row[1] || '-'), leftValueX, y);
      });

      rightHeader.forEach(function(row, index) {
        const y = headerStartY + index * rowGap;
        doc.setFont('helvetica', 'bold');
        doc.text(row[0], rightLabelX, y);
        doc.setFont('helvetica', 'normal');
        doc.text(String(row[1] || '-'), rightValueX, y);
      });

      const tableStartY = headerStartY + leftHeader.length * rowGap + 8;

      const rows = currentMaterials.map(function(item) {
        return [
          materialNameForPDF(item),
          String(item.qty),
          item.unit,
          money(item.unitCost),
          money(item.totalCost)
        ];
      });

      doc.autoTable({
        startY: tableStartY,
        margin: { left: margin, right: margin, bottom: footerHeight + 8 },
        head: [['Material', 'Qty', 'Unit', 'Unit Cost', 'Total']],
        body: rows,
        theme: 'grid',
        pageBreak: 'auto',
        rowPageBreak: 'auto',
        styles: {
          font: 'helvetica',
          fontSize: 7.5,
          cellPadding: 3,
          overflow: 'linebreak',
          valign: 'top',
          lineWidth: 0.4
        },
        headStyles: {
          fillColor: [249, 250, 251],
          textColor: [75, 85, 99],
          lineColor: [223, 227, 234],
          fontStyle: 'bold'
        },
        columnStyles: {
          0: { cellWidth: tableWidth - 285 },
          1: { cellWidth: 42, halign: 'right' },
          2: { cellWidth: 88 },
          3: { cellWidth: 75, halign: 'right' },
          4: { cellWidth: 80, halign: 'right' }
        },
        didParseCell: function(data) {
          if (data.section === 'body' && data.column.index === 0 && String(data.cell.raw || '').includes('Panels feature:')) {
            data.cell.styles.minCellHeight = 24;
          }
        }
      });

      const totalLabelX = margin + tableWidth - 205;
      const totalValueX = margin + tableWidth;
      const totalsHeight = 48;
      let totalsStartY = doc.lastAutoTable.finalY + 24;

      if (totalsStartY + totalsHeight > usableBottomY) {
        doc.addPage();
        totalsStartY = margin + 18;
      }

      doc.setFontSize(9);
      doc.setTextColor(23, 32, 51);
      doc.setFont('helvetica', 'normal');
      doc.text('Subtotal:', totalLabelX, totalsStartY);
      doc.text(money(subtotal), totalValueX, totalsStartY, { align: 'right' });

      doc.text('HST 13%:', totalLabelX, totalsStartY + 14);
      doc.text(money(hst), totalValueX, totalsStartY + 14, { align: 'right' });

      doc.setFont('helvetica', 'bold');
      doc.text('Total with tax:', totalLabelX, totalsStartY + 28);
      doc.text(money(totalWithTax), totalValueX, totalsStartY + 28, { align: 'right' });

      const totalPages = doc.internal.getNumberOfPages();
      for (let pageIndex = 1; pageIndex <= totalPages; pageIndex += 1) {
        doc.setPage(pageIndex);
        drawPdfFooter(pageIndex, totalPages);
      }

      doc.save(pdfSafeFileName(projectName) + '-materials-list.pdf');
    }

    function resetExample() {
      document.getElementById('projectName').value='';
      document.getElementById('projectAddress').value='';
      document.getElementById('needDelivery').value='no';
      document.getElementById('deliveryNote').value='';
      updateDeliveryNotice();
      document.getElementById('system').value='standing_seam';
      document.getElementById('manufacturer').value='Cascadia Metals LTD';
      updateSteelOptions(false);
      document.getElementById('gauge').value='24GA';
      syncFlashingGaugeOptions(false);
      document.getElementById('flashingGauge').value='24GA';
      document.getElementById('coating').value='PVDF';
      applyCascadiaMaterialOptions('PVDF', 'Black');
      applyMaterialAvailabilityRules();
      document.getElementById('pitch').value='6/12';
      document.getElementById('flatRoofSlope').value='1%';
      
      document.getElementById('area').value='2500';
      document.getElementById('wasteFactor').value='0';
      document.getElementById('flatArea').value='0';
      document.getElementById('eaves').value='180';
      document.getElementById('rakes').value='160';
      document.getElementById('ridges').value='85';
      ['eaves', 'ridges'].forEach(function(type) {
        const config = proPitchConfig(type);
        const checkbox = document.getElementById(config.enabledId);
        const rows = document.getElementById(config.rowsId);
        if (checkbox) checkbox.checked = false;
        if (rows) rows.textContent = '';
        syncProPitch(type, false);
      });
      document.getElementById('hips').value='60';
      document.getElementById('valleys').value='45';
      document.getElementById('walls').value='35';
      document.getElementById('steps').value='25';
      document.getElementById('parapet').value='0';
      document.getElementById('lockType').value='mechanical';
      document.getElementById('panelsFeature').value='Plain panel';
      document.getElementById('snowRetentionSpacing').value='none';
      if (document.getElementById('vmaxTowerVentQty')) document.getElementById('vmaxTowerVentQty').value='0';
      materialsManuallyEdited = false;
      recommendedMaterialsSnapshot = [];
      removedMaterialsHistory = [];
      updateInputLockState();
      calculateMaterials();
      setupCollapsibleSections();
    }

    function runCalculatorTests() {

      document.getElementById('wasteFactor').value = '10';
      const ridgeCapProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'Ridge Cap'; });
      console.assert(calculateProduct(ridgeCapProduct).qty === 10, 'Ridge Cap should calculate using ridge length only with selected waste.');

      const perforatedJProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'J Flashing - Perforated'; });
      console.assert(calculateProduct(perforatedJProduct).qty === 19, 'Perforated J should calculate ridge x2 / 10 with selected waste.');

      const plainJProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'J Flashing - plain'; });
      console.assert(calculateProduct(plainJProduct).qty === 14, 'Plain J should calculate hips x2 / 10 with selected waste.');
      document.getElementById('wasteFactor').value = '0';


      document.getElementById('manufacturer').value = 'Cascadia Metals LTD';
      updateSteelOptions(false);
      document.getElementById('coating').value = 'PVDF';
      document.getElementById('finish').value = 'Glossy';
      document.getElementById('gauge').value = '24GA';
      document.getElementById('flashingGauge').value = '24GA';
      const stepFlashingProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'Step Flashing'; });
      console.assert(catalogUnitCost(stepFlashingProduct) === 39, 'Step Flashing PVDF 24GA should cost 39.');

      document.getElementById('manufacturer').value = 'SSAB';
      updateSteelOptions(false);
      console.assert(catalogUnitCost(stepFlashingProduct) === 40, 'Step Flashing SSAB should cost 40.');

      const deliveryProductOnePerOrder = PRODUCT_CATALOG.find(function(p) { return p.uuid === '36-delivery'; });
      document.getElementById('needDelivery').value = 'outside_gta';
      document.getElementById('wasteFactor').value = '25';
      const deliveryOnePerOrderCalc = calculateProduct(deliveryProductOnePerOrder);
      console.assert(deliveryOnePerOrderCalc.qty === 1, 'Delivery should always be 1 per order.');
      console.assert(deliveryOnePerOrderCalc.totalCost === 300, 'Outside GTA delivery should be exactly 300.');
      updateDeliveryNotice();
      console.assert(document.getElementById('deliveryResponsibilityNotice').style.display === 'block', 'Delivery notice should show when delivery is selected.');
      document.getElementById('needDelivery').value = 'no';
      document.getElementById('wasteFactor').value = '0';

      console.assert(document.getElementById('flatRoofSlope'), 'Flat roof slope dropdown should exist.');
      console.assert(document.querySelectorAll('.form-section').length >= 7, 'Input form should be split into visual sections.');

      console.assert(document.getElementById('wasteFactor').options.length === 26, 'Waste factor dropdown should contain values from 0 to 25.');
      console.assert(document.getElementById('wasteFactor').options[0].value === '0', 'First waste factor option should be 0.');
      console.assert(document.getElementById('wasteFactor').options[25].value === '25', 'Last waste factor option should be 25.');

      document.getElementById('wasteFactor').value = '10';
      const wasteTestProduct = { uuid:'test-waste', name:'Waste Test Trim', measurement:'EAVES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' };
      document.getElementById('eaves').value = '91';
      const wasteTestCalc = calculateProduct(wasteTestProduct);
      console.assert(wasteTestCalc.qty === 11, 'Waste factor should apply before rounding up: 91/10*1.10 = 10.01 => 11.');
      document.getElementById('eaves').value = '180';
      document.getElementById('wasteFactor').value = '0';


      console.assert(!document.querySelector('.project-help'), 'Google autocomplete note should be removed.');

      document.getElementById('manufacturer').value = 'Cascadia Metals LTD';
      updateSteelOptions(false);
      document.getElementById('coating').value = 'PVDF';
      document.getElementById('gauge').value = '26GA';
      document.getElementById('flashingGauge').value = '26GA';
      document.getElementById('finish').value = 'Textured';
      applyMaterialAvailabilityRules();
      console.assert(getInputText('gauge') === '24GA', 'PVDF should force panel gauge to 24GA.');
      console.assert(getInputText('flashingGauge') === '24GA', 'PVDF should force flashing gauge to 24GA.');
      console.assert(Array.from(document.getElementById('gauge').options).some(function(o) { return o.value === '26GA' && o.disabled && o.textContent.includes('unavailable for PVDF'); }), 'PVDF should show 26GA panel gauge as unavailable.');
      console.assert(Array.from(document.getElementById('flashingGauge').options).some(function(o) { return o.value === '26GA' && o.disabled && o.textContent.includes('unavailable for PVDF'); }), 'PVDF should show 26GA flashing gauge as unavailable.');
      console.assert(getInputText('finish') === 'Glossy', 'PVDF should force Glossy finish.');

      const masterFlashingProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '34-master-flashing-auto'; });
      console.assert(masterFlashingProduct && calculateProduct(masterFlashingProduct).qty === 5, 'Master Flashing should calculate 2 per 1000 sq ft for 2500 sq ft.');

      const bathroomVentProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '35-bathroom-metal-vent-auto'; });
      console.assert(bathroomVentProduct && calculateProduct(bathroomVentProduct).qty === 3, 'Bathroom vents should calculate 1 per 1000 sq ft for 2500 sq ft.');

      const deliveryProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '36-delivery'; });
      document.getElementById('needDelivery').value = 'gta';
      console.assert(calculateProduct(deliveryProduct).qty === 0, 'GTA delivery should be free and hidden.');
      document.getElementById('needDelivery').value = 'outside_gta';
      const deliveryCalc = calculateProduct(deliveryProduct);
      console.assert(deliveryCalc.qty === 1 && deliveryCalc.unitCost === 300, 'Outside GTA delivery should be 300.');

      console.assert(document.getElementById('projectName'), 'Project name input should exist.');
      console.assert(document.getElementById('projectAddress'), 'Project address input should exist.');
      document.getElementById('manufacturer').value = 'SSAB';
      updateSteelOptions(false);
      console.assert(document.getElementById('gauge').options.length === 1, 'SSAB should have one gauge option.');
      console.assert(document.getElementById('flashingGauge').options.length === 1, 'SSAB should have one flashing gauge option.');
      console.assert(document.getElementById('flashingGauge').disabled === true, 'SSAB flashing gauge should be disabled.');
      console.assert(getInputText('gauge') === '0.5mm / approx. 25GA', 'SSAB gauge should be 0.5mm / approx. 25GA.');
      console.assert(getInputText('coating') === 'Pural', 'SSAB coating should be Pural.');
      console.assert(getInputText('finish') === 'Standard', 'SSAB finish should be Standard.');
      console.assert(Array.from(document.getElementById('color').options).map(function(o) { return o.value; }).includes('RR887'), 'SSAB colors should include RR887.');

      document.getElementById('manufacturer').value = 'Agway';
      updateSteelOptions(false);
      console.assert(Array.from(document.getElementById('gauge').options).map(function(o) { return o.value; }).join(',') === '26GA,24GA', 'Agway should only allow 26GA and 24GA.');
      console.assert(document.getElementById('flashingGauge').disabled === false, 'Agway flashing gauge should be editable.');
      console.assert(!Array.from(document.getElementById('coating').options).map(function(o) { return o.value; }).includes('Pural'), 'Agway should not allow Pural.');
      console.assert(Array.from(document.getElementById('finish').options).map(function(o) { return o.value; }).join(',') === 'Textured,Glossy', 'Agway should allow Textured and Glossy as finish, not coating.');

      console.assert(document.getElementById('pitch').options.length === 24, 'Pitch dropdown should contain values from 1/12 to 24/12.');
      console.assert(document.getElementById('pitch').options[0].value === '1/12', 'First pitch option should be 1/12.');
      console.assert(document.getElementById('pitch').options[23].value === '24/12', 'Last pitch option should be 24/12.');
      console.assert(document.getElementById('flatRoofSlope').options.length === 9, 'Flat roof slope dropdown should contain values from 1% to 4.76%.');
      console.assert(document.getElementById('flatRoofSlope').options[0].value === '1%', 'First flat roof slope option should be 1%.');
      console.assert(document.getElementById('flatRoofSlope').options[8].value === '4.76%', 'Last flat roof slope option should be 4.76%.');
      document.getElementById('manufacturer').value = 'Cascadia Metals LTD';
      updateSteelOptions(false);
      document.getElementById('gauge').value = '24GA';
      syncFlashingGaugeOptions(false);
      document.getElementById('flashingGauge').value = '26GA';
      document.getElementById('coating').value = 'PVDF';
      document.getElementById('finish').value = 'Textured';
      console.assert(selectedStandingSeamPanelPrice().price === 4.30, 'PVDF 24GA standing seam panel price should be 4.30/SF.');

      document.getElementById('manufacturer').value = 'SSAB';
      updateSteelOptions(false);
      console.assert(selectedStandingSeamPanelPrice().price === 4.50, 'SSAB GreenCoat Pural 25GA standing seam panel price should be 4.50/SF.');

      document.getElementById('manufacturer').value = 'Agway';
      updateSteelOptions(false);
      document.getElementById('gauge').value = '26GA';
      syncFlashingGaugeOptions(false);
      document.getElementById('flashingGauge').value = '26GA';
      document.getElementById('coating').value = 'SMP';
      document.getElementById('finish').value = 'Glossy';
      console.assert(selectedStandingSeamPanelPrice().price === 3.35, 'SMP 26GA Glossy standing seam panel price should be 3.35/SF.');

      document.getElementById('finish').value = 'Textured';
      console.assert(selectedStandingSeamPanelPrice().price === 3.50, 'SMP Textured 26GA Textured standing seam panel price should be 3.50/SF.');

      document.getElementById('gauge').value = '24GA';
      document.getElementById('flashingGauge').value = '26GA';
      document.getElementById('coating').value = 'SMP';
      document.getElementById('finish').value = 'Textured';
      console.assert(selectedStandingSeamPanelPrice().price === 4.00, 'Panel price should use panel gauge 24GA.');
      console.assert(STANDING_SEAM_TRIM_PRICES[trimPriceKey()].eave === 21, 'Trim price should use flashing gauge 26GA.');

      document.getElementById('flashingGauge').value = '26GA';
      const trimKey = trimPriceKey();
      console.assert(trimKey === '26GA_SMP_Textured', 'Trim price key should use flashing gauge, not panel gauge.');
      console.assert(STANDING_SEAM_TRIM_PRICES[trimKey].eave === 21, '26GA SMP Textured eave flashing should cost 21.');

      const htProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'Underlayment (Titanium PSU-30)'; });
      const htCalc = calculateProduct(htProduct);
      console.assert(htCalc.unitCost === 135, 'Titanium PSU-30 should cost 135 per roll.');

      const drainageProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '364688c1-8378-4934-ad42-1b9d5bc48e8f'; });
      const drainageCalc = calculateProduct(drainageProduct);
      console.assert(drainageProduct.itemType === 'material', 'Drainage Mat should be a material.');
      console.assert(drainageProduct.coverage === 360, 'Drainage Mat coverage should be 360 sq ft per roll.');
      console.assert(drainageCalc.unit === 'Roll', 'Drainage Mat should be sold by roll.');
      console.assert(drainageCalc.unitCost === 360, 'Drainage Mat should cost 360 per roll.');

      const strappingProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'Strapping 1x3x12'; });
      console.assert(strappingProduct.system === 'metal_tiles', 'Strapping should only be included for metal tiles.');
      console.assert(strappingProduct.cost === 3, 'Strapping should cost 3 per piece.');

      console.assert(!PRODUCT_CATALOG.some(function(p) { return p.name === 'Standing Seam Panels'; }), 'Standing Seam Panels duplicate row should be removed.');
      console.assert(!PRODUCT_CATALOG.some(function(p) { return p.uuid === 'c3423c66-75e5-4fa2-8142-73f5b5768a33'; }), 'Old Standing Seam panel row should be removed.');
      console.assert(!PRODUCT_CATALOG.some(function(p) { return p.uuid === '66f363c8-32e1-40b4-a36d-a34cd7332af7'; }), 'Old New Construction panel row should be removed.');
      document.getElementById('system').value = 'standing_seam';
      calculateMaterials();
      console.assert(currentMaterials.filter(function(i) { return String(i.name).toLowerCase().includes('standing seam'); }).length === 1, 'All item types should show only one Standing Seam panel row.');

      const snowProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'S-5! Colorgard snow guards'; });
      document.getElementById('snowRetentionSpacing').value = 'every_other';
      console.assert(catalogUnitCost(snowProduct) === 23, 'S-5 Colorgard every other seam should cost 23 per LF.');
      document.getElementById('snowRetentionSpacing').value = 'every_seam';
      console.assert(catalogUnitCost(snowProduct) === 30, 'S-5 Colorgard every seam should cost 30 per LF.');

      const screwsProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '75-screws-standing-seam'; });
      console.assert(catalogUnitCost(screwsProduct) === 20, 'Screws should cost 20 per 250 pcs box.');
      const screwsCalc = calculateProduct(screwsProduct);
      console.assert(screwsCalc.unit === 'Box (250 pcs)', 'Screws should be sold in boxes of 250 pcs.');

      const clipsProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '76-clips-mechanical-lock'; });
      console.assert(catalogUnitCost(clipsProduct) === 0.30, 'Mechanical lock clips should still resolve base unit price correctly.');
      const clipsCalc = calculateProduct(clipsProduct);
      console.assert(clipsCalc.unit === 'Box (1000 pcs)', 'Mechanical lock clips should be sold in boxes of 1000 pcs.');
      console.assert(clipsCalc.unitCost === 300, 'Mechanical lock clips should cost 300 per 1000 pcs box.');

      const snapClipsProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '76-clips-snap-lock'; });
      console.assert(catalogUnitCost(snapClipsProduct) === 0.50, 'Snap lock clips should cost 0.50 each before box rounding.');
      const snapClipsCalc = calculateProduct(snapClipsProduct);
      console.assert(snapClipsCalc.unit === 'Box (250 pcs)', 'Snap lock clips should be sold in boxes of 250 pcs.');
      console.assert(snapClipsCalc.unitCost === 125, 'Snap lock clips should cost 125 per 250 pcs box.');

      document.getElementById('system').value = 'standing_seam';
      document.getElementById('lockType').value = 'mechanical';
      document.getElementById('panelsFeature').value = 'Stability ribs';
      calculateMaterials();
      console.assert(selectedPanelsFeature() === 'Stability ribs', 'Panels feature should store selected option.');
      console.assert(currentMaterials.some(function(i) { return i.uuid === '76-clips-mechanical-lock'; }), 'Mechanical lock selection should include mechanical clips.');
      console.assert(!currentMaterials.some(function(i) { return i.uuid === '76-clips-snap-lock'; }), 'Mechanical lock selection should exclude snap clips.');

      document.getElementById('lockType').value = 'snap';
      calculateMaterials();
      console.assert(currentMaterials.some(function(i) { return i.uuid === '76-clips-snap-lock'; }), 'Snap lock selection should include snap clips.');
      console.assert(!currentMaterials.some(function(i) { return i.uuid === '76-clips-mechanical-lock'; }), 'Snap lock selection should exclude mechanical clips.');

      document.getElementById('snowRetentionSpacing').value = 'none';
      const snowCalc = calculateProduct(snowProduct);
      console.assert(snowCalc.qty === 0, 'Snow retention should be removable from calculation.');

      console.assert(PRODUCT_CATALOG.every(function(p) { return p.sku; }), 'Every catalog product should have a temporary SKU.');
      const sealantProduct = PRODUCT_CATALOG.find(function(p) { return p.name === 'Titebond Metal Sealant Cartridge'; });
      console.assert(sealantProduct && sealantProduct.coverage === 300, 'Titebond sealant should use 300 sq ft per cartridge.');
      console.assert(calculateProduct(sealantProduct).qty === 9, 'Titebond sealant should calculate 9 cartridges for 2500 sq ft.');
      console.assert(catalogUnitCost(sealantProduct) === 12.5, 'Titebond sealant should cost 12.50 per cartridge.');
      document.getElementById('color').value = 'Black';
      console.assert(selectedShopifySku(sealantProduct) === 'TBMSCBL', 'Black Titebond sealant should use SKU TBMSCBL.');
      document.getElementById('color').value = 'Grey';
      console.assert(selectedShopifySku(sealantProduct) === 'TBMSCGR', 'Grey Titebond sealant should use SKU TBMSCGR.');
      document.getElementById('color').value = 'Brown';
      console.assert(selectedShopifySku(sealantProduct) === 'TBMSCBR', 'Brown Titebond sealant should use SKU TBMSCBR.');
      document.getElementById('color').value = 'Clear';
      console.assert(selectedShopifySku(sealantProduct) === 'TBMSCCL', 'Clear Titebond sealant should use SKU TBMSCCL.');
      console.assert(selectedShopifySku(bathroomVentProduct) === 'BMV', 'Bathroom Metal Vent should use SKU BMV.');
      console.assert(selectedShopifySku(masterFlashingProduct) === 'MSF', 'Master Flashing should use SKU MSF.');
      console.assert(selectedShopifySku(drainageProduct) === 'DRM360', 'Drainage Mat 360 SF should use SKU DRM360.');

      document.getElementById('coating').value = 'SMP';
      document.getElementById('finish').value = 'Glossy';
      document.getElementById('flashingGauge').value = '26GA';
      console.assert(catalogUnitCost(stepFlashingProduct) === 30.0, 'SMP 26GA step flashing should cost 30.');

      document.getElementById('flashingGauge').value = '24GA';
      console.assert(catalogUnitCost(stepFlashingProduct) === 34.0, 'SMP 24GA step flashing should cost 34.');

      document.getElementById('finish').value = 'Textured';
      document.getElementById('flashingGauge').value = '26GA';
      console.assert(catalogUnitCost(stepFlashingProduct) === 32.0, 'SMP Textured 26GA step flashing should cost 32.');

      document.getElementById('flashingGauge').value = '24GA';
      console.assert(catalogUnitCost(stepFlashingProduct) === 35.0, 'SMP Textured 24GA step flashing should cost 35.');

      document.getElementById('coating').value = 'PVDF';
      console.assert(catalogUnitCost(stepFlashingProduct) === 39.0, 'PVDF 24GA step flashing should cost 39.');

      document.getElementById('manufacturer').value = 'SSAB';
      console.assert(catalogUnitCost(stepFlashingProduct) === 40.0, 'SSAB step flashing should cost 40.');

      document.getElementById('flatArea').value = '1000';
      document.getElementById('flatRoofSlope').value = '2%';
      const baseProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '37-flat-roof-base'; });
      const capProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === '38-flat-roof-cap'; });
      console.assert(baseProduct && calculateProduct(baseProduct).qty === 12, 'Base should calculate from total flat area, slope adjustment, and 86 sq.ft. roll coverage.');
      console.assert(capProduct && calculateProduct(capProduct).qty === 14, 'Cap should calculate from total flat area, slope adjustment, and 72 sq.ft. roll coverage.');
      console.assert(catalogUnitCost(baseProduct) === 95, 'Base should cost $95 per roll.');
      console.assert(catalogUnitCost(capProduct) === 89, 'Cap should cost $89 per roll.');
      document.getElementById('flatArea').value = '0';
      document.getElementById('flatRoofSlope').value = '1%';

      console.assert(PRODUCT_CATALOG.length >= 30, 'Catalog should contain metal roof rows from CSV.');
      console.assert(measurementValue('EAVES_LENGTH,RAKES_LENGTH') === 340, 'Combined measurements should sum correctly.');
      document.getElementById('parapet').value = '21';
      document.getElementById('wasteFactor').value = '10';
      const parapetProduct = PRODUCT_CATALOG.find(function(p) { return p.uuid === 'e7e26415-d47e-462d-b582-15f19b2e14b8'; });
      const parapetCalc = calculateProduct(parapetProduct);
      console.assert(parapetCalc.qty === 3, 'Parapet should calculate as length / 10 with selected waste factor.');
      console.assert(parapetCalc.unitCost === 40, 'Parapet should cost $40 per piece.');
      document.getElementById('wasteFactor').value = '0';
      resetExample();
      console.assert(currentMaterials.length > 0, 'Standing seam should produce material rows.');
      const starter = PRODUCT_CATALOG.find(function(p) { return p.name === 'Starter'; });
      const starterCalc = calculateProduct(starter);
      console.assert(starterCalc.qty === 18, 'Starter should calculate 18 pcs at 0% waste: 180 ft / 10 ft.');
      document.getElementById('eavesProEnabled').checked = true;
      document.getElementById('eavesProRows').textContent = '';
      addProPitchRow('eaves', 87, '6/12', false);
      addProPitchRow('eaves', 93, '9/12', false);
      const starterProCalc = calculateProduct(starter);
      console.assert(starterProCalc.qty === 19, 'Pro eaves should round each slope to 10 ft: 87=>90 and 93=>100, total 190=>19 pcs.');
      console.assert(starterProCalc.flashingBreakdown.length === 2 && starterProCalc.flashingBreakdown[0].qty === 9 && starterProCalc.flashingBreakdown[1].qty === 10, 'Starter production breakdown should show qty by pitch.');
      document.getElementById('ridgesProEnabled').checked = true;
      document.getElementById('ridgesProRows').textContent = '';
      addProPitchRow('ridges', 42, '6/12', false);
      addProPitchRow('ridges', 43, '9/12', false);
      const perforatedJProCalc = calculateProduct(PRODUCT_CATALOG.find(function(p) { return p.uuid === '67-j-flashing-perforated'; }));
      const plainJProCalc = calculateProduct(PRODUCT_CATALOG.find(function(p) { return p.uuid === '68-j-flashing-hips'; }));
      console.assert(!perforatedJProCalc.flashingBreakdown || perforatedJProCalc.flashingBreakdown.length === 0, 'Perforated J flashing should not generate production breakdown data.');
      console.assert(!plainJProCalc.flashingBreakdown || plainJProCalc.flashingBreakdown.length === 0, 'Plain J flashing should not generate production breakdown data.');
      console.assert(!perforatedJProCalc.extraBreakdownNote, 'Perforated J flashing should not generate extra production notes.');
      console.assert(!plainJProCalc.extraBreakdownNote, 'Plain J flashing should not generate extra production notes.');
      document.getElementById('ridgesProEnabled').checked = false;
      document.getElementById('ridgesProRows').textContent = '';
      document.getElementById('system').value = 'metal_tiles';
      updateSystemSpecificUI();
      console.assert(!document.getElementById('eavesProEnabled').checked && document.getElementById('eavesProCard').classList.contains('is-hidden'), 'Pro pitch mode should be disabled and hidden for metal tiles.');
      document.getElementById('system').value = 'standing_seam';
      updateSystemSpecificUI();
      document.getElementById('eavesProEnabled').checked = true;
      const eavesRows = document.getElementById('eavesProRows');
      eavesRows.textContent = '';
      addProPitchRow('eaves', 87, '6/12', false);
      addProPitchRow('eaves', 93, '9/12', false);
      console.assert(effectiveMeasuredLength('eaves') === 190, 'Pro mode should adjust 87 ft + 93 ft eaves to 190 ln.ft. for 10 ft flashings.');
      console.assert(calculateProduct(starter).qty === 19, 'Starter should use adjusted pro eaves length: 190 ft / 10 ft = 19 pcs.');
      document.getElementById('eavesProEnabled').checked = false;
      eavesRows.textContent = '';
      document.getElementById('system').value='metal_tiles';
      calculateMaterials();
      console.assert(currentMaterials.some(function(i) { return i.name === 'Metal Tiles'; }), 'Metal tiles system should include Metal Tiles row.');
      document.getElementById('system').value = 'standing_seam';
      document.getElementById('lockType').value = 'mechanical';
      calculateMaterials();
      console.assert(!document.getElementById('sumRows'), 'Rows summary should be removed.');
      console.assert(document.getElementById('sumMaterialDetails').textContent.includes('Panels thickness'), 'Material details should include panel thickness.');
      console.assert(document.getElementById('hstAmount').textContent !== '$0.00', 'HST amount should calculate below the table.');
      console.assert(currentMaterials[0].name.includes('Standing Seam - Mechanical Lock 1.5 inch'), 'Panel name should be dynamic and include lock type.');
      console.assert(currentMaterials.some(function(i) { return i.name.includes('J Flashing - Plain - 10ln. ft.'); }), 'J Flashing for hips should display as J Flashing - Plain with metal details.');
    }

    loadGooglePlacesAutocomplete();

    populateFlatRoofSlopeOptions('1%');
    populateWasteFactorOptions('0');
    populatePitchOptions('6/12');
    setupProPitchControls();
    
    updateSteelOptions(false);
    setupAutoCalculate();
    setupCollapsibleSections();
    updateDeliveryNotice();
    calculateMaterials();
    loadShopifyCatalogPrices();
    if (new URLSearchParams(window.location.search).has('debug')) {
      runCalculatorTests();
    }
